export default {translation: {
  // ATL-970: a failed Supabase read is no longer indistinguishable from an empty collection, so
  // it now has something to say to the merchant.
  dataLoad: {
    failed: 'Ошибка загрузки данных. Пожалуйста, перезапустите приложение.',
    partial: 'Не удалось обновить: {{collections}}. Показаны сохранённые данные — перезапустите приложение.',
    collections: {
      products: 'товары',
      productCategories: 'категории',
      stores: 'магазины',
      users: 'сотрудники',
      suppliers: 'поставщики',
      constants: 'настройки',
      organization: 'организация',
    },
  },
  appName: 'ATLAS',
  save: 'Сохранить',
  delete: 'Удалить',
  deleting: 'Удаление...',
  isReturned: 'Возврат',
  search: 'Поиск',
  searching: 'Поиск...',
  searchHint: 'Введите номер телефона или имя',
  clientSearchFailed: 'Не удалось выполнить поиск. Проверьте интернет и попробуйте снова',
  weight: 'Вес',
  price: 'Цена',
  accumulate: 'Накопить',
  reduct: 'Потратить',
  phone: 'Телефон',
  name: 'Имя',
  create: 'Создать',
  none: 'Нет',
  paymentMethods: 'Методы оплаты',
  purchaseMethods: 'Методы покупки',
  discountOptions: 'Доступные скидки',
  configure: 'Настроить',
  refresh: 'Обновить',
  language: 'Язык',
  select: 'Выбрать',
  piece: 'шт',
  pieceLong: 'Штука',
  pcs: 'шт',
  kgLong: 'Килограмм',
  kg: 'кг',
  grLong: 'Грамм',
  gr: 'гр',
  lLong: 'Литр',
  l: 'л',
  mlLong: 'Миллилитр',
  ml: 'мл',
  notFound: 'Не найдено',
  updateApp: 'Обновить приложение',
  off: 'выкл',
  all: 'Все',
  total: 'Итого',
  filterByDate: 'Фильтр по дате',
  noItemsText: 'Ничего не найдено',
  notAllFieldsFilled: 'Не все поля заполнены либо заполнены неправильно',
  fieldIsRequiredError: 'Это поле обязательно для заполнения',
  invalidNumberError: 'Значение должно быть числом',
  minLengthError: 'Значение должно быть не меньше {{minLength}} символов',
  maxLengthError: 'Значение должно быть не больше {{maxLength}} символов',
  minError: 'Значение должно быть не меньше {{min}}',
  maxError: 'Значение должно быть не больше {{max}}',
  ingredientNotFoundError: "Ингредиент {{name}} продукта {{product}} не найден в списке товаров. Пожалуйста перепроверьте состав товара.",
  patternError: 'Неправильный формат {{type}}',
  emailTaken: 'Email уже занят',
  imageIsUploading: 'Идет загрузка изображений',
  add: 'Добавить',
  cancel: 'Отмена',
  confirm: 'Подтвердить',
  now: 'Сейчас',
  date: 'Дата',
  continue: 'Продолжить',
  notSaved: 'Не удалось сохранить',
  product: 'Товар',
  store: 'Филиал',
  organization: 'Организация',
  next: 'Далее',
  openLink: 'Открыть ссылку',
  supplier: 'Поставщик',
  suppliers: 'Поставщики',
  products: 'Товары',
  productSearchPlaceholder: 'Поиск товаров',
  billingAndPayment: 'Тарифы и Оплата',
  resetData: 'Сброс данных',
  misc: 'Разное',
  back: 'Назад',
  success: 'Успешно',
  printFailed: 'Не удалось напечатать. Проверьте принтер.',
  done: 'Готово',
  navigate: 'Перейти',
  role: 'Роль',
  permissionDenied: 'Доступ запрещен. Пожалуйста обратитесь к администратору',
  other: 'Другое',
  updateTimezone: 'Изменить часовой пояс',
  networkErrorText: 'Устройство оффлайн, имеются несохраненные данные. Пожалуйста не закрывайте приложение/вкладку пока не восстановится интернет соединение.',
  salesLimitUpgradeText: 'Ваши продажи достигли лимитов по вашему тарифу. В скором времени ваш аккаунт будет заблокирован. Пожалуйста перейдите на более высокий тариф.',
  failedPaymentAlertText: 'По вашему тарифу не прошел платеж. Пожалуйста проверьте наличие средств на вашей карте, в скором времени будет повторная попытка оплаты.',
  blockedAlertText: 'Ваш аккаунт заблокирован из-за превышения лимитов продаж. Пожалуйста перейдите на платный или более высокий тариф.',
  paymentLapsedAlertText: 'Подписка не продлилась: не прошла оплата тарифа. Пожалуйста проверьте способ оплаты или продлите тариф в разделе «Тарифы и Оплата».',
  upgrade: 'Перейти',
  updatePaymentMethod: 'Обновить способ оплаты',
  differentTimeZoneText: 'Часовой пояс на вашем устройстве отличается от часового пояса филиала. Все даты будут отображаться в часовом поясе филиала. Местное время филала - {{time}}',
  cashFromCashbox: 'Наличные с кассы',
  extractedCash: 'Изъятые наличные',
  bankAccount: 'Банковский счет',
  cash: 'Наличные',
  paymentTerminal: 'Терминал',
  find: 'Найти',
  deleted: '[Удалено]',
  error: 'Ошибка. Если она повторяется пожалуйста обратитесь в поддержку',
  // ATL-2004: a guarded save whose outcome could not be established (global/Firebase/writeOutcome.ts).
  writeOutcomeUnknown: {
    sale: 'Не удалось подтвердить сохранение продажи. Проверьте список продаж, прежде чем пробивать снова.',
    record: 'Не удалось подтвердить, что операция сохранилась. Проверьте список операций, прежде чем сохранять снова.',
  },
  deleteWarningTitle: 'Подтверждение удаления',
  deleteWarningText: 'Это действие нельзя отменить.',
  notANumberError: 'Значения должны быть числами, пожалуйста проверьте правильность заполнения',
  amountMustBePositive: 'Сумма должна быть числом больше 0',
  amountMustNotBeNegative: 'Сумма не может быть отрицательной',
  // ATL-1371 — см. комментарий в en/translation.js: эти два ключа читались, но не были заданы,
  // и пользователю показывалось само имя ключа.
  quantityMustBePositive: 'Количество должно быть больше 0',
  priceMustBeNonNegative: 'Цена не может быть отрицательной',
  quantityTooLargeError: 'Слишком большое количество. Введите значение не больше {{max}}.',
  lastServerUpdate: 'Последнее обновление с сервера',
  lastLocalUpdate: 'Последнее обновление локально',
  searchResults: 'Результаты поиска',
  csvExport: 'Экспорт в CSV',
  excelExport: 'Экспорт в Excel',
  importFileMalformedQuotes: 'в строке {{row}} кавычка в ячейке открыта и не закрыта, поэтому файл не прочитан — иначе строки ниже были бы потеряны. Сохраните файл как .xlsx и загрузите снова',
  sheetsExport: 'Экспорт в Google Sheets',
  batchEditProducts: 'Редактирование товаров',
  viewModeSwitch: 'Вид отображения:',
  sales: 'Продажи',
  moreSettings: 'Больше настроек',
  bonusValueChange: {
    addition: 'Пополнение бонусов',
    subtraction: 'Снятие бонусов',
    newBonusValue: 'Новое значение бонусов'
  },
  platformDependantSelect: {
    chooseOther: 'Выберите пункт из списка'
  },
  cartView: {
    discount: 'Скидка',
    totalWithoutDiscount: 'Итого без скидки',
    bonusReduction: 'Cписание бонусов',
    punchCardReduction: 'Бесплатный товар',
    total: 'Итого',
    bonusAccumulation: 'Накопление бонусов',
    totalPurchasePrice: 'Общая закупочная цена',
  },
  changeView: {
    change: 'Сдача',
    otherValue: 'Другая сумма',
  },
  clientView: {
    newClient: 'Новый клиент',
    b2cClient: 'Физ. лицо',
    b2bClient: 'Организация',
    errorForPhoneNumberFormat: 'Номер телефона должен начинаться на +',
    errorForPhoneNumberLength: 'Номер телефона должен быть больше 9 цифр',
  },
  support: {
    support: 'Поддержка',
    welcome: 'Здравствуйте! 👋 Это поддержка Atlas. Опишите ваш вопрос, обычно отвечаем в течение 1-2 минут.',
    newMessage: 'Новое сообщение от поддержки',
    newMessageFrom: 'Новое сообщение от {{name}}',
    newMessageAttachment: 'Прислали вложение',
    back: 'Назад',
    placeholder: 'Сообщение',
    emptyTitle: 'Чем можем помочь?',
    replyTime: 'Обычно отвечаем в течение 1-2 минут',
    awaitingReply: 'Ответим в течение 1-2 минут 🙌',
    retry: 'Не отправлено · Повторить',
    fileTooLarge: 'Файл слишком большой (макс. 25 МБ)',
    a11yAttachImage: 'Прикрепить изображение',
    a11yAttachFile: 'Прикрепить файл',
    a11ySend: 'Отправить',
    draftTitle: 'Предложенные товары',
    draftHint: 'Откройте каждый товар, проверьте данные, укажите закупочную цену и сохраните.',
    draftOpen: 'Открыть и сохранить',
    draftDismiss: 'Не нужно',
    draftSaved: 'Сохранено',
    draftSalePrice: 'Предложенная цена: {{price}}',
    draftSalePricePerUnit: 'Предложенная цена: {{price}} за {{unit}}',
    draftNoPrice: 'Цену продажи укажете сами',
    draftAlreadyInCatalogue: 'Товар с таким названием уже есть в каталоге',
    draftAllSaved: 'Все товары сохранены',
    draftDismissed: 'Вы отказались от этих товаров',
    draftExpired: 'Предложение устарело',
    draftLoadError: 'Не удалось загрузить предложение',
    draftRetry: 'Повторить',
    draftActionError: 'Не получилось. Попробуйте ещё раз.',
    draftOpenInApp: 'Сохранить товары можно в разделе «Товары», когда доступ к приложению откроется.',
    draftBanner: 'Черновик от поддержки. Проверьте данные, укажите закупочную цену и остальные обязательные поля, затем нажмите «Сохранить».',
    quickReplyAddProduct: 'Добавить товар',
    quickReplyNewSale: 'Новая продажа',
  },
  helpCenter: {
    helpCenter: 'Справочный центр',
    greeting: 'Здравствуйте!',
    howCanWeHelp: 'Чем мы можем помочь?',
    chat: 'Чат',
    help: 'Помощь',
    moreOptions: 'Дополнительные опции',
    recentUpdates: 'Недавние сообщения',
    checkLatestNews: 'Отлично! Если у вас возникнут...',
    askQuestion: 'Задать вопрос',
    ourBotAndTeam: 'Наш бот и команда могут помочь',
    startConversation: 'Начать разговор',
    recentConversations: 'Недавние сообщения',
    newMessagesAvailable: 'У вас {{count}} новое сообщение',
    viewPastConversations: 'Посмотреть прошлые разговоры',
    openChatForMessages: 'Откройте чат, чтобы увидеть сообщения',
    loadingChat: 'Загрузка чата...',
    chatWithSupport: 'Чат с поддержкой',
    webChatInstructions: 'Нажмите кнопку ниже, чтобы открыть окно чата в новой вкладке.',
    mobileChatInstructions: 'Нажмите кнопку ниже, чтобы начать общение с нашей службой поддержки.',
    openChat: 'Открыть чат',
    chatUnavailable: 'Чат недоступен',
    chatConfigurationMissing: 'Служба чата неправильно настроена. Пожалуйста, обратитесь в поддержку.',
    goBack: 'Назад',
    whatIsNew: 'Новости и обновления',
    contactSupport: 'Форма связи с поддержкой',
    pricing: 'Стоимость',
    gettingStarted: 'Начало работы',
    welcomeMessage: 'Добро пожаловать, {{name}}! Давайте разберемся как пользоваться ATLAS и как начать вести в нем учет вашего бизнеса 💫',
    done: 'Выполнено',
    skip: 'Пропустить',
    ourInstagram: 'ATLAS в Instagram',
    writeToWhatsapp: 'Написать в поддержку через WhatsApp',
    AtlasAppStore: 'ATLAS в App Store',
    AtlasGooglePlay: 'ATLAS в Google Play',
    AtlasWeb: 'Веб-версия ATLAS для компьютеров',
    termsOfUse: 'Пользовательское соглашение',
    privacyPolicy: 'Политика конфиденциальности',
    eula: 'Лицензионное соглашение',
    instructionsForretail: 'Инструкция для торговли',
    instructionsForonline: 'Инструкция для онлайн продаж',
    instructionsForrestaurant: 'Инструкция для кафе, ресторанов и точек на вынос',
    instructionsFormanufacture: 'Инструкция для производств и цехов',
    instructionsForsuppliers: 'Инструкция для дистрибьюторов и поставщиков',
    instructionsForservices: 'Инструкция для бизнесов в сфере услуг',
    instructionsForother: 'Инструкции',
    instructionsForundefined: 'Инструкции',
  },
  ingredientsView: {
    composition: 'Состав',
    costOfOnePiece: 'Себестоимость 1шт',
    costTotal: 'Себестоимость общая',
    totalQuantity: 'Общее количество',
    quantity: 'Количество',
    price: 'Стоимость',
    totalPrice: 'Общая стоимость',
    addIngredientsHint: 'Добавьте ингредиенты, нажав на иконку плюсика выше',
  },
  newSale: {
    newSale: 'Новая продажа',
    saleSaved: 'Продажа сохранена',
    receiptNotFiscalized: 'Продажа сохранена, но чек не фискализирован',
    receiptNotFiscalizedWithReason: 'Продажа сохранена, но чек не фискализирован: {{reason}}',
    openSalesHistory: 'Открыть историю продаж',
    tapToOpenSalesHistory: 'Нажмите, чтобы открыть историю продаж',
    unfiscalizedSalesInSession: 'Чеков без фискального признака: {{count}}. Продажи сохранены.',
    fiscalOperatorNotConfigured: 'фискальный оператор не настроен',
    fiscalLoginFailed: 'не удалось войти в ОФД',
    fiscalOperatorUnsupported: 'этот фискальный оператор не поддерживается приложением',
    receiptPrintBlocked: 'Не удалось напечатать чек — разрешите всплывающие окна для этого сайта.',
    priceType: 'Тип цены',
    selectPriceType: 'Выберите тип цены',
    defaultPrice: 'Базовая цена',
    retail: 'Розница',
    priceTypeAutoChanged: 'Тип цены изменен на {{name}}',
    interfaceSettingsTitle: 'Настройки Новой Продажи',
    checkoutStyle2Steps: 'Чекаут в два шага',
    internalReceiptWidth: 'Ширина внутреннего чека',
    internalReceiptFontSize: 'Размер шрифта внутреннего чека',
    showDateField: 'Показать поле Дата продажи',
    showStoreField: 'Показать поле Филиал',
    showCommentField: 'Показать поле Комментарий к продаже',
    showTableNumberField: 'Показать поле Номер стола',
    mergeSimilarItemsIntoOneRow: 'Объединять одинаковые товары в одну строку',
    mergeSimilarItemsIntoOneRowTrue: 'Да, при добавлении товара в корзину существующего в корзине товара, количество существующего товара увеличится',
    mergeSimilarItemsIntoOneRowFalse: 'Нет, при добавлении товара в корзину существующего в корзине товара, создастся новая строка',
    multipleProductSelection: 'Возможность выбирать несколько товаров при добавлении в корзину для мобильных экранов',
    interfaceSettings: 'Настройки интерфейса',
    savedCarts: 'Открытые чеки',
    addCartItem: 'Добавить товар',
    addCartItemEmptyHint: 'Здесь пока нет товаров. Добавьте первый, и он сразу появится в этом списке.',
    addCartItemSampleOnlyHint: 'Пока здесь только тестовый товар из примера. Добавьте свои товары, чтобы продавать их.',
    addCartItemAskAdmin: 'Попросите администратора добавить товары.',
    addCartItemCreateProduct: 'Создать товар',
    addCartItemNewProduct: 'Новый товар',
    addSelectedToCart: 'Добавить в чек',
    editCartItem: 'Редактировать товар',
    shiftNotOpenedError: 'Нет прав на продажу без смены. Откройте пожалуйста сперва смену. Текущую продажу вы можете отложить чтобы пробить ее позже.',
    gridLeftWidth: 'Ширина левой колонки (10 = половина экрана)',
    withoutDiscount: 'Без скидки',
    name: 'Название',
    quantity: 'Количество/Вес',
    purchasePrice: 'Закупочная цена',
    salePrice: 'Цена продажи',
    individualProductDiscount: 'Скидка на товар',
    deleteFromCart: 'Удалить с корзины',
    firstPaymentValue: 'Первая сумма',
    firstPaymentMethodAndValue: 'Первый метод оплаты и сумма',
    secondPaymentMethodAndValue: 'Второй метод оплаты и сумма',
    secondSum: 'Вторая сумма',
    printCheck: 'Печать чека',
    mixedPayment: 'Смешанная оплата',
    postPayment: 'Постоплата',
    saveCartForLater: 'Отложить',
    receipt: 'Чек',
    commonError: 'Либо в корзине нет товаров, либо не выбран метод оплаты',
    cartItemsCannotBeEmpty: 'Добавьте товары в корзину',
    addProductToCheckout: 'Добавьте товар, чтобы оформить продажу',
    priceMissingError: 'У товара нет цены для этого магазина. Обновите каталог или укажите цену.',
    mixedPaymentFirstPaymentNotNumber: 'Cумма первого метода оплаты в смешанной оплате должна быть числом',
    delvieryPriceNotANumberError: 'Стоимость доставки должна быть числом',
    choosePurchaseMethodError: 'Пожалуйста выберите метод покупки',
    choosePaymentMethodError: 'Пожалуйста выберите метод оплаты',
    noPaymentMethodsForStore: 'Нет доступных методов оплаты. Перейдите в Настройки → Методы оплаты, чтобы включить для этого филиала.',
    noPurchaseMethodsForStore: 'Нет доступных методов покупки. Перейдите в Настройки → Методы покупки, чтобы включить для этого филиала.',
    mixedPaymentSecondPaymentMethodEmpty: 'Пожалуйста выберите второй метод оплаты для смешанной оплаты',
    mixedPaymentFirstPaymentAmountEmpty: 'Пожалуйста заполните сумму первого метода оплаты для смешанной оплаты',
    mixedPaymentSecondPaymentIsSameAsFirst: 'Пожалуйста выберите другой второй метод оплаты для смешанной оплаты',
    deliveryPaymentSourceEmptyError: 'Пожалуйста выберите источник оплаты для доставки',
    deliveryAddressEmptyError: 'Укажите адрес доставки или выберите клиента с адресом',
    addProduct: 'Добавить товар',
    saleDate: 'Дата продажи',
    tableNumber: 'Номер стола',
    comment: 'Комментарий',
    client: 'Клиент',
    proceedToPayment: 'К оплате',
    customProduct: 'Кастомный продукт',
    delivery: 'Доставка',
    deliveryPrice: 'Стоимость доставки',
    deliveryPaidByCustomer: 'Доставка оплачивается покупателем',
    deliveryPaidBySeller: 'Доставка оплачивается продавцом',
    deliveryAddress: 'Адрес доставки',
    deliveryIncludeInReceipt: 'Отобразить доставку в чеке для покупателя',
    appearance: 'Настройки интерфейса',
    internalReceipt: 'Настройки чека',
    deliveryDefaultSettings: 'Дефолтные значения доставки',
    defaultDeliveryPaidBy: 'Кем оплачивается доставка по дефолту',
    defaultDeliverySpendingCategory: 'Категория расходов для доставки',
    additionalFields: 'Дополнительные поля',
    other: 'Другое',
    showSaveCartForLater: 'Показывать кнопку "Отложить"',
    deliveryPaymentSourceWallet: 'Источник оплаты',
    showPurchasePriceInEditCartItem: 'Показать поле цена закупки на экране редактирования товара',
    showTotalPurchasePriceInCart: 'Показать общую закупочную цену в корзине',
    cannotSellOutOfStock: 'Недостаточно товара {{productName}} на складе',
    cannotSellOutOfStockIngredients: 'Недостаточно ингредиента {{ingredientName}} для товара {{productName}}',
    stockShortageTitle: 'Недостаточно товара на складе',
    stockShortageIngredientOf: 'ингредиент товара {{productName}}',
    stockShortageAvailable: 'В наличии: {{quantity}}',
    stockShortageAttempted: 'Вы пытаетесь продать: {{quantity}}',
    stockShortageReceiveHint: 'Если товар уже пришёл, оформите приёмку — количество можно будет изменить перед сохранением. Корзина сохранится.',
    stockShortageReceive: 'Оформить приёмку',
    stockShortageAskAdmin: 'Чтобы продать больше, чем есть в наличии, нужно оформить приёмку. Обратитесь к администратору.',
    stockShortageBackToCart: 'Вернуться к корзине',
    discountAmount: 'На сумму',
    discountAmountPopupTitle: 'Сумма скикдки'
  },
  salesHistory: {
    salesHistory: 'История продаж',
    saleDetail: 'Продажа',
    returnSale: 'Возврат продажи',
    salesStats: 'Отчет по продажам',
    returnPresent: 'Был возврат',
    priceType: 'Тип цены',
    replaceProduct: 'Замена продукта',
    returnMoney: 'Возврат денег',
    chooseReturnItems: 'Пожалуйста выберите позиции для возврата',
    totalReturnedAmount: 'Итого к возврату товаров {{returnedQuantity}} на сумму {{amount}}',
    returnItem: 'Возвращать',
    returnQuantity: 'Кол-во к возврату',
    returnItemAmount: 'Сумма возврата',
    returnQuantityExceedsSold: 'Нельзя вернуть больше, чем было продано — {{name}}: продано {{sold}}',
    cumulativeRefundExceedsSale: 'По этой продаже уже возвращено {{alreadyReturned}} из {{refundable}}. Ещё один возврат на {{requested}} превысит сумму продажи. Если предыдущий возврат был ошибочным, сначала удалите его.',
    returnType: 'Способ возврата',
    moneyReturnType: 'Способ возврата денег',
    updateStockText: 'Добавить товар обратно на склад или списать?',
    takeBack: 'Добавить обратно',
    writeOff: 'Списать',
    returnReason: 'Причина возврата',
    returnReasons: 'Причины возвратов',
    comment: 'Комментарий',
    return: 'Сделать возврат',
    deleteSale: 'Удалить полностью продажу',
    cashbox: 'Касса',
    cashier: 'Кассир',
    client: 'Клиент',
    discount: 'скидка',
    totalWithoutDiscount: 'Итого без скидки',
    totalDiscount: 'Общая скидка',
    bonusReduction: 'Оплата бонусами',
    total: 'ИТОГО',
    payment: 'Оплата',
    thankYouForYourPurchase: 'Спасибо за покупку!',
    returnFiled: 'Оформлен возврат',
    date: 'Дата - ',
    reason: 'Причина - ',
    returnAmount: 'Сумма возврата - ',
    returnUpdateStockText: 'Возвращенные товары',
    inputPhoneNumber: 'Укажите пожалуйста номер',
    send: 'Отправить',
    sendToWhatsapp: 'Отправить чек на Whatsapp',
    printReceipt: 'Распечатать фискальный чек',
    sendToSms: 'Отправить чек через SMS',
    noSms: 'Нет смс',
    copyReceipt: 'Скопировать чек',
    notFiscalized: 'У чека отсутствует фискальный признак',
    ofdError: 'Что-то с ОФД',
    ofdErrorWithReason: 'Ошибка в ОФД - {{reason}}',
    retryOfd: 'Пробить чек еще раз в ОФД',
    alreadyFiscalized: 'Этот чек уже пробит в ОФД — повторно не отправляем',
    fiscalStateUnverifiable: 'Не удалось проверить, пробит ли чек. Проверьте интернет и повторите — повторно чек не отправлен',
    receiptContentUnavailable: 'Чек пробит, но его текст не сохранился — откройте его в кабинете ОФД',
    printInternalReceipt: 'Распечатать чек',
    printReturnReceipt: 'Распечатать возвратный чек',
    printInvoice: 'Распечатать накладную',
    printOptions: 'Печать',
    printInternalReceiptOption: 'Внутренний чек',
    printInvoiceOption: 'Накладная',
    printTemplatesOption: 'Шаблоны печати',
    salePayment: 'Оплата продажи',
    paid: 'Оплачено',
    notPaid: 'Не оплачено',
    paymentDate: 'Дата оплаты',
    fileReturn: 'Оформить возврат',
    deleteReturn: 'Удалить возврат',
    periodContainsNotFiscalizedSales: 'За этот период есть продажи без фискального признака.',
    batchFiscalizationRetry: 'Пробить повторно продажи в ОФД без фискального признака',
    deliveryPaidByCustomer: 'Доставка оплачена покупателем',
    deliveryPaidBySeller: 'Доставка оплачена продавцом',
    delivery: 'Доставка',
    deliveryAddress: 'Адрес доставки',
    deliveryPrice: 'Стоимость доставки',
    clientAddress: 'Адрес клиента',
  },
  productStocks: {
    productStocks: 'Остатки товаров',
    productStockMovementHistory: 'История движения товара',
    newProduct: 'Создание продукта',
    openingBalance: 'Начальный остаток',
    stockReset: 'Сброс остатков',
    sale: 'Продажа',
    writeOff: 'Списание',
    revision: 'Ревизия',
    return: 'Возврат',
    supply: 'Приемка',
    manufacture: 'Производство',
    transfer: 'Перемещение',
    deleteTransfer: 'Удаление перемещения',
    deleteSupply: 'Удаление приемки',
    deleteManufacture: 'Удаление производства',
    deleteSale: 'Удаление продажи',
    deleteReturn: 'Удаление возврата',
    deleteWriteOff: 'Удаление списания',
    deleteRevision: 'Удаление ревизии',
    complexSale: 'Комплексная продажа',
    deleteComplexSale: 'Удаление комплексной продажи',
    editComplexSale: 'Изменение комплексной продажи',
    manualChange: 'Ручное изменение',
    type: 'Тип',
    increment: 'Изменение',
    previousInStock: 'Предыдущее значение',
    possibleStockError: 'Ошибка, возможно нужен пересчет предыдущей операции',
    instructions: 'Инструкция',
    changeStock: 'Изменение количества',
    createSupply: 'Создать приемку',
    createWriteOff: 'Сделать списание',
    createRevision: 'Сделать ревизию',
    productInfo: 'Данные по товару',
    showInImportantSection: 'Показывать в важных товарах',
    stockThreshold: 'Количество при котором нужно подсветить красным',
    startingStock: 'Количество на начало периода',
    newProductCount: 'Количество при создании продукта',
    saleCount: 'Продажи',
    deleteSaleCount: 'Удаленные продажи',
    complexSaleCount: 'Комплексные продажи',
    editComplexSaleCount: 'Измененные комплексные продажи',
    deleteComplexSaleCount: 'Удаленные комплексные продажи',
    writeOffCount: 'Списания',
    deleteWriteOffCount: 'Удаленные списания',
    supplyCount: 'Приемки',
    deleteSupplyCount: 'Удаленные приемки',
    manufactureCount: 'Производства',
    deleteManufactureCount: 'Удаленные производства',
    transferCount: 'Перемещения',
    returnCount: 'Возвраты',
    deleteReturnCount: 'Удаленные возвраты',
    totalMovement: 'Итог',
    endingStockShouldBe: 'Количество к концу периода (должно быть)',
    revisionCount: 'Ревизии',
    deleteRevisionCount: 'Удаленные ревизии',
    manualChangeCount: 'Ручное изменение',
    endingStockWithRevisions: 'Количество с учетом ревизий',
    currentStock: 'Текущее количестов в системе',
    noMovement: 'За этот период не было изменений по остаткам товара',
    editMovement: 'Редактировать движение',
    foundError: 'Нашли ошибку в отчете?',
    foundErrorDescription: 'Такое возможно из-за нестабильного интернет соединения. Укажите правильное значение по остаткам данного товара',
    recalculate: 'Пересчитать',
    productStocksInstructions: 'Инструкция по остаткам',
    importantProducts: 'Важные продукты',
    inStock: 'В наличии',
    weeklySales: '7дн. продажи',
    weeklyWriteOffs: '7дн. списания',
    newStockValue: 'Новое значение',
    successManualUpdate: 'Успешно. Пожалуйста перезагрузите данную страницу чтобы увидеть изменения',
    savedPastDate: 'Сохранено прошлой датой',
    savedToServerLater: 'Сохранено на сервере позже из-за проблем с интернетом',
    purchaseSum: 'Остаток в наличии по закупочной цене',
    saleSum: 'Остаток в наличии по продажной цене',
    isService: 'Услуга',
    activeOrders: 'Активные заказы',
  }, 
  revisions: {
    revisions: 'Ревизии',
    revision: 'Ревизия',
    revisionStats: 'Отчет по ревизиям',
    missing: 'В минусе',
    surplus: 'В плюсе',
    balance: 'Баланс',
    listMissing: 'Список в минусе',
    listSurplus: 'Список в плюсе',
    otherProductMixUp: 'Перепутали с другим товаром',
    forgotToCreateSupply: 'Забыли сделать приемку',
    supplyError: 'Неправильно сделали приемку',
    forgotToWriteOff: 'Забыли списать',
    forgotToMarkASale: 'Не пометили продажу',
    wrongCount: 'Неправильно посчитали',
    other: 'Неизвестно',
    total: 'Итого',
    totalWithCorrections: 'Итого с учетом исправлений',
    category: 'Категория',
    name: 'Название',
    quantity: 'Кол-во',
    quantityFact: 'Кол-во факт',
    amount: 'Сумма',
    reason: 'Причина',
    correctedAmount: 'Исправленная сумма',
    deletedProductsError: 'Ревизия не сохранена: эти товары удалены и не могут войти в ревизию — {{products}}. Поставьте им «Кол-во факт» равным «Кол-во» и сохраните снова. Введённые данные остаются на экране.',
  },
  writeOffs: {
    ingredientQuantityTooLargeError: 'Количество ингредиента {{name}}, которое даёт это списание, слишком большое. Списываемое количество по одному товару должно быть не больше {{max}}.',
    writeOffs: 'Списания',
    writeOff: 'Списание',
    writeOffStats: 'Отчет по списаниям',
    quantity: 'Количество',
    reason: 'Причина',
    amount: 'Сумма',
    writeOffReasons: 'Причины списаний',
  },
  supplies: {
    supplies: 'Приемки',
    supply: 'Приемка',
    deletedSupplier: 'Удаленный поставщик',
    paid: 'Оплачено',
    notPaid: 'Не оплачено',
    totalSuppliesSum: 'Общая сумма поставок за период',
    choosePaymentMethod: 'Выберите метод оплаты',
    instructions: 'Инструкция по заполнению',
    supplyDate: 'Дата приемки',
    supplyReturnIsPresent: 'Есть ли товары к возврату?',
    returnPresentTrue: 'Есть возврат',
    returnPresentFalse: 'Без возврата',
    supplyPricesHaveUpdated: 'Изменились ли цены?',
    pricesUpdatedTrue: 'Цены изменились',
    pricesUpdatedFalse: 'Цены не изменились',
    supplyItems: 'Товары',
    fillInBarcode: 'Введите штрих-код',
    returnMode: 'Режим возврата',
    supplyMode: 'Режим приемки',
    name: 'Название',
    purchasePrice: 'Закупочная цена',
    supplyQuantity: 'Привоз',
    returnQuantity: 'Возврат',
    sellPrice: 'Продажная цена',
    totalPrice: 'Итого',
    supplyTotal: 'Привоз итого',
    returnTotal: 'Возврат итого',
    total: 'Итого',
    invoiceScans: 'Фото накладной',
    takePhoto: 'Сделать фото',
    choosePhoto: 'Выбрать c галереи',
    invoicePayment: 'Оплата накладной',
    paymentDate: 'Дата оплаты',
    createPaymentTransaction: 'Создать автоматически платеж',
    stickers: 'Этикетки',
    payments: 'Оплаты',
    saveErrorName: 'Введите название',
    deleteSupplier: 'Удалить поставщика',
    fieldNotANumberError: '{{productName}}: {{fieldName}} должно быть числом',
    fieldTooLargeError: '{{productName}}: {{fieldName}} слишком большое. Введите значение не больше {{max}}.',
    totalFieldTooLargeError: '{{productName}}: суммарное значение «{{fieldName}}» по всем строкам этой поставки слишком большое. Сумма по одному товару должна быть не больше {{max}}.',
    instructionsLink: 'https://www.notion.so/atlas-app/What-are-Supplies-and-how-to-create-them-9956e87ae47b404c85a995d8f4f09456?pvs=4#f7aac3859a4a41fc91d9ff516f14e1d6',
  },
  // ATL-1440: Settings → API tokens (Atlas API v1 for AI agents and integrations).
  apiTokens: {
    title: 'API-токены',
    intro: 'API-токен подключает ИИ-агента (Claude, ChatGPT, Plank) или другую программу к Atlas. Токен действует от имени создавшего его администратора и только в этой организации. Каждое действие по токену записывается в журнал ниже.',
    notAvailable: 'API пока недоступен для этой организации: он открывается организациям, чьи данные уже переведены на новую базу.',
    undetermined: 'Не удалось проверить, доступен ли API для организации. Попробуйте позже.',
    create: 'Создать токен',
    name: 'Название',
    namePlaceholder: 'Например: Claude — отчёты',
    scopes: 'Права',
    scope_read: 'Чтение — всё (товары, остатки, продажи, приёмки, отчёты)',
    scope_read_products: 'Чтение: товары и цены',
    scope_read_stock: 'Чтение: остатки по складам',
    scope_read_sales: 'Чтение: продажи и выручка',
    scope_write_sales: 'Создание продаж',
    scope_write_products: 'Создание и изменение товаров',
    scope_write_danger: 'Опасные действия (удаление)',
    scope_draft_sales: 'Черновики продаж (вы проводите их сами)',
    scope_draft_acceptances: 'Черновики приёмок (вы проводите их сами)',
    scopeSoon: 'скоро',
    expiresIn: 'Срок действия',
    days: '{{count}} дн.',
    issue: 'Создать',
    cancel: 'Отмена',
    secretTitle: 'Токен создан',
    secretWarning: 'Скопируйте токен сейчас. Atlas хранит только его отпечаток и больше его не покажет.',
    copy: 'Скопировать',
    copied: 'Скопировано',
    done: 'Готово',
    noTokens: 'Токенов пока нет.',
    status_active: 'Активен',
    status_expired: 'Истёк',
    status_revoked: 'Отозван',
    expires: 'Действует до {{date}}',
    lastUsed: 'Использовался {{date}}',
    neverUsed: 'Ещё не использовался',
    createdBy: 'Создал(а): {{name}}',
    revoke: 'Отозвать',
    revokeTitle: 'Отозвать токен?',
    revokeText: 'Токен «{{name}}» перестанет работать сразу. Отменить это нельзя: для доступа понадобится новый токен.',
    auditTitle: 'Журнал действий',
    auditEmpty: 'Записей пока нет.',
    loadMore: 'Показать ещё',
    actorAgent: 'Агент «{{name}}»',
    actorUser: '{{name}}',
    outcome_success: 'успешно',
    outcome_denied: 'отказано',
    outcome_error: 'ошибка',
    action_api_token_create: 'создал(а) токен',
    action_api_token_revoke: 'отозвал(а) токен',
    action_whoami: 'проверил подключение',
    action_stores_list: 'запросил список магазинов',
    action_products_list: 'запросил товары',
    action_sales_list: 'запросил продажи',
    action_acceptances_list: 'запросил приёмки',
    action_reports_revenue_by_day: 'запросил выручку по дням',
    action_reports_top_products: 'запросил топ товаров',
    action_reports_stock_balances: 'запросил остатки',
    action_reports_stock_balance: 'запросил остаток товара',
    action_reports_sales_summary: 'запросил сводку продаж',
    action_products_get: 'открыл товар',
    action_sales_get: 'открыл продажу',
    action_mcp_initialize: 'подключился через MCP',
    action_mcp_tools_list: 'запросил список инструментов MCP',
    action_mcp_tools_call: 'вызвал неизвестный инструмент MCP',
    action_mcp_batch: 'обратился к MCP',
    action_mcp_request: 'обратился к MCP',
    action_mcp_list_products: 'MCP: запросил товары',
    action_mcp_get_product: 'MCP: открыл товар',
    action_mcp_list_stocks: 'MCP: запросил остатки',
    action_mcp_get_stock: 'MCP: запросил остаток товара',
    action_mcp_list_sales: 'MCP: запросил продажи',
    action_mcp_get_sale: 'MCP: открыл продажу',
    action_mcp_sales_summary: 'MCP: запросил сводку продаж',
    action_sales_draft_create: 'предложил продажу',
    action_acceptances_draft_create: 'предложил приёмку',
    action_api_draft_create: 'предложил черновик',
    action_api_draft_apply: 'провёл(а) черновик агента',
    action_api_draft_dismiss: 'отклонил(а) черновик агента',
    action_drafts_list: 'запросил черновики организации',
    action_drafts_get: 'проверил черновик',
    action_api_token_oauth_approve: 'разрешил(а) подключение ИИ-ассистента',
    action_api_token_oauth_deny: 'отклонил(а) подключение ИИ-ассистента',
    action_api_token_oauth_code_reuse: 'повторно использовал код подключения — подключение отозвано',
    action_api_token_oauth_refresh_reuse: 'повторно использовал старый ключ — подключение отозвано',
    action_mcp_get_account: 'MCP: проверил подключение',
    action_mcp_list_stores: 'MCP: запросил список магазинов',
    action_mcp_list_acceptances: 'MCP: запросил приёмки',
    action_mcp_revenue_by_day: 'MCP: запросил выручку по дням',
    action_mcp_top_products: 'MCP: запросил топ товаров',
    action_mcp_list_drafts: 'MCP: запросил черновики организации',
    action_mcp_get_draft: 'MCP: проверил черновик',
    action_mcp_preview_sale_draft: 'MCP: показал черновик продажи на подтверждение',
    action_mcp_create_sale_draft: 'MCP: предложил продажу',
    action_mcp_preview_acceptance_draft: 'MCP: показал черновик приёмки на подтверждение',
    action_mcp_create_acceptance_draft: 'MCP: предложил приёмку',
    error_too_many_active_tokens: 'У организации уже максимум активных токенов. Отзовите ненужный.',
    error_generic: 'Не получилось. Попробуйте ещё раз.',
    nameRequired: 'Укажите название',
  },
  apiDrafts: {
    title: 'Черновики от ИИ-агента',
    intro: 'Продажи и приёмки, которые ИИ-агент подготовил по API-токену. Агент ничего не проводит сам: откройте черновик, проверьте и сохраните его как обычно — или отклоните.',
    empty: 'Открытых черновиков нет.',
    agent: 'ИИ-агент',
    kind_sale: 'Продажа',
    kind_acceptance: 'Приёмка',
    proposedBy: '{{name}} (токен выдал(а) {{person}}) · {{date}}',
    expires: 'Действует до {{date}}',
    purchasePrice: 'закуп {{price}}',
    openSale: 'Открыть в продаже',
    openAcceptance: 'Открыть приёмку',
    dismiss: 'Отклонить',
    cancel: 'Отмена',
    dismissTitle: 'Отклонить черновик?',
    dismissText: 'Ничего не будет проведено. Агент увидит, что черновик отклонён.',
    otherStore: 'Черновик для другого магазина. Откройте его, работая в этом магазине.',
    storeMissing: 'Магазина из черновика больше нет.',
    supplierMismatch: 'Приёмка оформляется на одного поставщика, а у этих товаров он не общий. Черновик можно только отклонить.',
    productsMissing: 'Этих товаров больше нет в каталоге: {{names}}. Черновик можно только отклонить.',
    savedConfirming: 'Сохранено на этом устройстве, подтверждаем…',
    savedRefused: 'Запись сохранена, но не привязана к черновику: {{reason}} Не проводите черновик повторно — отклоните его.',
    saleBanner: 'Корзина из черновика: {{name}}. Проверьте и оформите продажу как обычно.',
    acceptanceBanner: 'Приёмка из черновика: {{name}}. Проверьте и сохраните как обычно.',
    linkRefused: 'Сохранено, но не привязано к черновику агента: {{reason}}',
    refusal_predates_proposal: 'запись создана раньше черновика.',
    refusal_in_other_organization: 'запись из другой организации.',
    refusal_not_found: 'запись не найдена.',
    refusal_store_mismatch: 'запись сохранена в другом магазине.',
    refusal_no_draft_products: 'в записи нет ни одного товара из черновика.',
    refusal_record_already_claimed: 'эта запись уже привязана к другому черновику.',
    refusal_permission_denied: 'у вашей роли нет доступа к этому черновику.',
    refusal_invalid_firestore_id: 'неверный идентификатор записи.',
    refusal_other: 'сервер отклонил привязку.',
    error_already_decided: 'Черновик уже проведён или отклонён.',
    error_permission_denied: 'У вашей роли нет доступа к этому черновику.',
    error_generic: 'Не получилось. Попробуйте ещё раз.',
  },
  // ATL-1694: connecting Claude / ChatGPT to Atlas over MCP — the consent screen and the help screen.
  aiAssistants: {
    title: 'ИИ-ассистенты: Claude и ChatGPT',
    whatTitle: 'Что это',
    whatText: 'Atlas можно подключить к Claude или ChatGPT. После этого вы просто задаёте ассистенту вопросы о своём бизнесе, а он сам смотрит данные в Atlas.',
    canReadTitle: 'Что ассистент может посмотреть',
    canRead: 'Магазины, товары и цены, остатки по складам, продажи, выручку по дням, самые продаваемые товары, приёмки и черновики организации.',
    canWriteTitle: 'Что ассистент может записать',
    canWrite: 'Только черновики продаж и приёмок. Ассистент ничего не продаёт сам и не меняет остатки и деньги. Черновик ждёт вас в разделе Настройки → Черновики от ИИ-агента: вы открываете его, проверяете и сохраняете сами — или отклоняете.',
    needTitle: 'Что нужно',
    need_admin: 'Вы — администратор организации в Atlas. Подключение подтверждает только администратор.',
    need_org: 'Подключение включено для вашей организации. Статус — ниже.',
    need_claude: 'Для Claude: аккаунт на claude.ai. На бесплатном тарифе можно добавить один собственный коннектор. В тарифах Team и Enterprise коннектор сначала добавляет владелец (Owner) рабочего пространства.',
    need_chatgpt: 'Для ChatGPT: тариф, где можно добавлять собственные MCP-серверы (обычно Plus, Pro, Business или Enterprise). В Business и Enterprise это может быть разрешено только администраторам рабочего пространства.',
    statusTitle: 'Статус вашей организации',
    status_available: 'Можно подключать.',
    status_notAdmin: 'Подключить может только администратор организации. Попросите его или войдите под администратором.',
    statusLoadError: 'Не удалось загрузить статус. Проверьте интернет и попробуйте ещё раз.',
    unavailable_organization_not_on_supabase: 'Подключение ИИ-ассистентов доступно только организациям, которые уже переведены на новую базу данных Atlas. Ваша организация пока не переведена.',
    unavailable_not_enabled: 'Подключение ИИ-ассистентов для вашей организации ещё не включено.',
    unavailable_undetermined: 'Не удалось проверить, доступно ли подключение. Попробуйте через несколько минут.',
    serverTitle: 'Адрес сервера',
    serverText: 'Этот адрес нужно вставить в Claude или ChatGPT. Копируйте его целиком.',
    copy: 'Скопировать',
    copied: 'Скопировано',
    claudeTitle: 'Как подключить Claude',
    claudeStep1: 'Откройте claude.ai (или приложение Claude) и войдите в свой аккаунт.',
    claudeStep2: 'Откройте Customize → Connectors.',
    claudeStep3: 'Нажмите Add custom connector.',
    claudeStep4: 'В поле Name напишите Atlas, в поле URL вставьте адрес сервера. Поля OAuth Client ID и Client Secret оставьте пустыми. Если Claude спросит, какой OAuth-клиент использовать, выберите Use Claude\'s published identity или Register automatically.',
    claudeStep5: 'Нажмите Add, затем Connect.',
    claudeStep6: 'Откроется страница Atlas. Войдите, если попросит. Проверьте, что доступ просит Claude (claude.ai), отметьте нужные права и нажмите «Разрешить».',
    claudeStep7: 'Вы вернётесь в Claude — Atlas подключён. В чате его можно включать и выключать через «+» → Connectors.',
    claudeTeam: 'Team и Enterprise: сначала владелец (Owner) добавляет коннектор в Organization settings → Connectors → Add → Custom → Web с этим адресом. Потом каждый участник подключается сам: Customize → Connectors → Atlas → Connect.',
    claudeCodeTitle: 'Claude Code (для разработчиков)',
    claudeCodeText: 'Выполните в терминале команду ниже. Затем в Claude Code введите /mcp, выберите atlas и войдите — откроется та же страница Atlas.',
    chatgptTitle: 'Как подключить ChatGPT',
    chatgptStep1: 'Откройте chatgpt.com и войдите в свой аккаунт.',
    chatgptStep2: 'Откройте Plugins (или Apps), нажмите «+» → Add custom MCP server. Если такого пункта нет: Settings → Apps & Connectors → Advanced settings → включите Developer mode, вернитесь в Apps & Connectors и нажмите Create.',
    chatgptStep3: 'В поле Name напишите Atlas, в поле URL вставьте адрес сервера, в Authentication выберите OAuth.',
    chatgptStep4: 'Подтвердите, что понимаете предупреждение о собственных серверах, и нажмите Create (или Connect).',
    chatgptStep5: 'Откроется страница Atlas. Проверьте, что доступ просит ChatGPT (chatgpt.com), отметьте нужные права и нажмите «Разрешить».',
    chatgptStep6: 'В новом чате включите Atlas через «+» (или меню инструментов) и задайте вопрос.',
    chatgptNote: 'Названия пунктов меню в ChatGPT иногда меняются. Если не нашли нужный — ищите в настройках «MCP», «Connectors» или «Developer mode».',
    checkTitle: 'Как проверить, что всё работает',
    checkText: 'Напишите ассистенту: «Что ты можешь посмотреть в Atlas?» Он перечислит, что ему доступно, — это зависит от прав, которые вы отметили. Если отмечено «Смотреть все данные», попросите: «Покажи мои магазины в Atlas» — он перечислит ваши магазины. А в разделе Настройки → API-токены появится подключение Claude или ChatGPT со временем последнего использования.',
    examplesTitle: 'Примеры запросов',
    examplesText: 'Скопируйте и вставьте в чат с ассистентом:',
    example_revenue: 'Какая выручка была вчера по всем магазинам?',
    example_topProducts: 'Какие 10 товаров продавались лучше всего за прошлую неделю?',
    example_stock: 'Сколько осталось молока на складе «Центральный»?',
    example_salesToday: 'Сколько продаж было сегодня и на какую сумму?',
    example_acceptanceDraft: 'Подготовь черновик приёмки на склад «Центральный»: молоко 1 л — 20 шт по 400 ₸.',
    writeTitle: 'Как ассистент записывает',
    writeStep1: 'Вы просите подготовить продажу или приёмку.',
    writeStep2: 'Ассистент сначала показывает, что именно запишет: магазин, товары и количество (в приёмке — ещё и закупочные цены; цены продажи возьмутся из прайса при оформлении) — и спрашивает, всё ли верно.',
    writeStep3: 'Только после вашего «да» он создаёт черновик. Claude и ChatGPT тоже могут спросить разрешение на это действие — подтвердите его.',
    writeStep4: 'Откройте Настройки → Черновики от ИИ-агента, проверьте черновик и сохраните его как обычную продажу или приёмку — или отклоните.',
    writeNote: 'Черновик хранится 7 дней. Пока вы его не сохранили, ничего не продано, а остатки и деньги не изменились.',
    writeScopesNote: 'Чтобы ассистент мог готовить черновики, при подключении отметьте не только «Предлагать черновики», но и «Смотреть все данные»: иначе он не узнает ваши магазины и товары. Поставщика в черновике приёмки ассистент не указывает — он берётся из карточек товаров, как в обычной приёмке.',
    troubleTitle: 'Если что-то не работает',
    trouble_admin: 'Atlas пишет, что подключить ассистента может только администратор организации, — войдите в Atlas под администратором или попросите его подключить ассистента.',
    trouble_org: 'Atlas пишет, что подключение доступно только организациям, переведённым на новую базу данных, или что для вашей организации оно ещё не включено, — посмотрите статус выше. Пока организация не переведена, подключить ассистента нельзя; если подключение не включено, напишите в поддержку.',
    trouble_url: 'Ассистент пишет, что не может связаться с сервером (например, Couldn\'t reach the MCP server) — проверьте, что адрес вставлен точно, без пробелов и лишних символов.',
    trouble_reconnect: 'Ассистент перестал видеть Atlas или просит войти снова — доступ отозван или истёк, либо у того, кто его разрешил, больше нет прав администратора. Подключите заново.',
    trouble_scopes: 'Ассистент не видит нужные данные или не может создать черновик — при подключении не было отмечено это право. Отзовите подключение и подключите заново, отметив нужные права.',
    trouble_rate: 'Ассистент пишет, что запросов слишком много (например, rate limited или 429), — одно подключение может делать до 60 запросов в минуту, а все подключения и токены организации вместе — до 120. Подождите минуту и повторите.',
    trouble_support: 'Не помогло — напишите в поддержку из приложения.',
    disconnectTitle: 'Как отключить',
    disconnect_atlas: 'В Atlas: Настройки → API-токены → нужное подключение → «Отозвать». Доступ прекращается сразу.',
    disconnect_claude: 'В Claude: Customize → Connectors → Atlas → Remove.',
    disconnect_chatgpt: 'В ChatGPT: в настройках Apps (или Plugins) найдите Atlas и удалите его.',
    disconnect_admin: 'Если у человека, который подключил ассистента, забрали права администратора, подключение перестаёт работать само.',
    disconnectNote: 'Удаление в Claude или ChatGPT не всегда отзывает доступ в Atlas. Надёжнее всего — отозвать подключение в Atlas.',
    openTokens: 'Открыть API-токены',
    openDrafts: 'Открыть черновики',
    openHelp: 'Как подключить Claude или ChatGPT',
    consentTitle: 'Подключение ИИ-ассистента',
    consentAsking: '{{client}} просит доступ к данным организации «{{organization}}».',
    client_claude: 'Claude',
    client_chatgpt: 'ChatGPT',
    client_local: 'Программа на вашем компьютере',
    client_other: 'Другое приложение',
    consentHost: 'Доступ получит: {{host}}',
    consentClientName: 'Приложение называет себя «{{name}}»',
    consentLocalWarning: 'Это программа на вашем компьютере, например Claude Code. Разрешайте, только если вы сами её только что запустили.',
    consentOtherWarning: 'Atlas не знает это приложение. Разрешайте, только если вы сами начали подключение и доверяете адресу выше.',
    consentScopesTitle: 'Что ассистенту можно делать',
    consentScope_read: 'Смотреть все данные: товары, цены, остатки, продажи, выручку, приёмки и черновики',
    consentScope_read_products: 'Смотреть товары и цены',
    consentScope_read_stock: 'Смотреть остатки по складам',
    consentScope_read_sales: 'Смотреть продажи и выручку',
    consentScope_draft_sales: 'Предлагать черновики продаж',
    consentScope_draft_acceptances: 'Предлагать черновики приёмок',
    consentDraftNote: 'Черновик ничего не продаёт и не меняет остатки и деньги, пока вы сами не сохраните его в приложении. Для черновиков отметьте и «Смотреть все данные» — иначе ассистент не узнает ваши магазины и товары.',
    consentExpiresTitle: 'Сколько действует доступ',
    consentActor: 'Доступ будет действовать от вашего имени ({{name}}). Отозвать его можно в любой момент: Настройки → API-токены.',
    consentPickScope: 'Отметьте хотя бы одно право.',
    allow: 'Разрешить',
    deny: 'Отклонить',
    redirecting: 'Возвращаемся в {{client}}…',
    noRequest: 'Здесь подтверждается подключение Claude или ChatGPT к Atlas. Начните подключение в самом ассистенте — он откроет эту страницу.',
    blocked_not_admin: 'Подключить ИИ-ассистента может только администратор организации. Войдите под администратором или попросите его.',
    blocked_not_found: 'Запрос на подключение не найден. Начните подключение в Claude или ChatGPT заново.',
    blocked_stale: 'Запрос устарел — начните подключение в Claude или ChatGPT заново.',
    decisionError_request_not_pending: 'Запрос уже обработан — начните подключение в Claude или ChatGPT заново.',
    decisionError_request_expired: 'Запрос устарел — начните подключение в Claude или ChatGPT заново.',
    decisionError_mcp_not_enabled_for_organization: 'Подключение ИИ-ассистентов для вашей организации ещё не включено.',
    decisionError_mcp_disabled: 'Подключение ИИ-ассистентов сейчас выключено.',
    decisionError_organization_not_on_supabase: 'Подключение доступно только организациям, уже переведённым на новую базу данных Atlas.',
    decisionError_too_many_active_tokens: 'У организации уже максимум активных токенов и подключений. Отзовите ненужное в Настройки → API-токены.',
    decisionError_invalid_scopes: 'Эти права выдать нельзя. Начните подключение заново.',
    decisionError_invalid_expiry: 'Выберите срок подключения из списка.',
    decisionError_mcp_access_undetermined: 'Atlas не смог проверить, можно ли вашей организации подключить ассистента. Повторите через минуту.',
    decisionError_organization_access_undetermined: 'Atlas не смог проверить, можно ли вашей организации подключить ассистента. Повторите через минуту.',
    decisionError_forbidden: 'Подключить ИИ-ассистента может только администратор организации.',
    networkError: 'Нет связи с сервером. Проверьте интернет и попробуйте ещё раз.',
    genericError: 'Не получилось. Попробуйте ещё раз.',
    retry: 'Повторить',
    goHome: 'На главную',
    connectedThrough_claude: 'Подключение Claude',
    connectedThrough_chatgpt: 'Подключение ChatGPT',
    connectedThrough_local: 'Подключение программы на компьютере',
    connectedThrough_other: 'Подключение ИИ-приложения',
    connectionHost: 'адрес: {{host}}',
    revokeConnectionText: '{{client}} сразу потеряет доступ к Atlas. Чтобы снова пользоваться ассистентом, подключите его заново.',
  },
  settings: {
    settings: 'Настройки',
    apiTokens: 'API-токены',
    agentDrafts: 'Черновики от ИИ-агента',
    aiAssistants: 'ИИ-ассистенты: Claude и ChatGPT',
    productCategories: 'Категории товаров',
    ecommerceProductsTable: 'Таблица товаров для интернет-магазина',
    loyaltySettings: 'Настройки программы лояльности',
    marketplaceSettings: 'Настройки онлайн-каталога',
    productTags: 'Теги для интернет-магазина',
    productTag: 'Тег товара',
    discountOptions: 'Доступные скидки',
    suppliers: 'Поставщики',
    users: 'Сотрудники',
    inactiveUsers: 'Неактивные сотрудники',
    roles: 'Роли и доступы',
    stores: 'Филиалы',
    wallets: 'Денежные счета',
    paymentMethods: 'Методы оплаты',
    purchaseMethods: 'Методы покупки',
    priceTypes: 'Ценовые категории',
    productUnits: 'Единицы измерения товаров',
    organizationSettings: 'Настройки организации',
    saleSettings: 'Настройки продаж',
    writeOffReasons: 'Причины списаний',
    returnReasons: 'Причины возвратов',
    recurringSpendings: 'Ежемесячные расходы',
    adminSpendingCategories: 'Категории расходов для админов',
    spendingCategories: 'Категории расходов для продавцов',
    billing: 'Тарифы и Оплата',
    checkForUpdates: 'Проверить обновления',
    checkingForUpdates: 'Проверяем обновление',
    version: 'Версия',
    resetData: 'Сброс данных',
    appearance: 'Внешний вид',
    systemTheme: 'Системная',
    lightTheme: 'Светлая',
    darkTheme: 'Тёмная',
    withoutFiscalization: 'Без фискализации',
    atLeastOnePurchaseMethodError: 'В организации должен быть хотя бы один активный метод покупки',
    atLeastOnePriceTypeError: 'Необходим хотя бы один тип цены',
    onePriceTypeMustBeDefault: 'Один тип цены должен быть установлен по умолчанию',
    duplicatePriceTypeIds: 'Обнаружены дублирующиеся ID типов цен',
    allPriceTypesMustHaveNames: 'Все типы цен должны иметь названия',
    priceTypesSaved: 'Типы цен успешно сохранены',
    errorSavingPriceTypes: 'Ошибка сохранения типов цен',
    cannotDeleteRetailPriceType: 'Нельзя удалить розничный тип цены',
    cannotDeleteCashPaymentMethodError: 'Нельзя удалить метод оплаты Наличными',
    destinationWalletsNotFilledError: 'Выберите счет зачисления для активных филиалов',
    walletTiedToPaymentMethodError: 'Счет привязан к методу оплаты, сперва отвяжите его с метода оплаты и попробуйте снова. Привязанные методы оплаты: {{paymentMethods}}',
    uniqueIdError: 'ID должен быть уникальным',
    priceTypesHint: 'Настройте дополнительные типы цен для ваших товаров, например - оптовые, в кредит/рассрочку, по акции, и тд). После добавления здесь нового типа цены появится новое поле при редактировании товара, где вы сможете указать эти цены. Далее при продаже вы сможете выбрать по какой цене сделать продажу.',
    autoCalculated: 'Рассчитывается автоматически',
    priceTypeName: 'Название типа цены',
    priceTypeId: 'ID типа цены',
    enterName: 'Введите название',
    enterId: 'Введите ID',
    scope: 'Область действия',
    perStore: 'Отдельные цены по филиалам',
    organizationWide: 'Общая цена на всю организацию',
    isDefault: 'Тип цены по умолчанию',
    isRequired: 'Обязательная цена',
    deletePriceType: 'Удалить тип цены',
    confirmDeletePriceType: 'Вы уверены, что хотите удалить этот тип цены?',
    addPriceType: 'Добавить тип цены',
    newPriceType: 'Новый тип цены',
    editPriceType: 'Редактировать тип цены',
    noPriceTypes: 'Нет типов цен',
    createFirstPriceType: 'Создайте первый тип цены для начала работы',
    priceTypeNameRequired: 'Название типа цены обязательно',
    priceTypeSaved: 'Тип цены успешно сохранен',
    priceTypeDeleted: 'Тип цены успешно удален',
    errorSavingPriceType: 'Ошибка при сохранении типа цены',
    errorDeletingPriceType: 'Ошибка при удалении типа цены',
    priceCalculation: 'Расчет цены',
    autoCalculateFromDefault: 'Авто-расчет от базовой цены',
    autoCalculateFromSalePrice: 'Авто-расчет от цены продажи (базовая цена)',
    manualPriceHint: 'Если автоматический расчет выключен, вы должны вручную установить цену для каждого товара',
    calculationType: 'Тип расчета',
    percentage: 'Процент',
    multiply: 'Умножить',
    adjust: 'Прибавить/вычесть',
    minQuantity: 'Минимальное количество',
    percentageHint: 'Например, 10 означает +10%, -10 означает -10%',
    multiplierHint: 'Например, 1.2 означает на 20% больше, 0.8 означает на 20% меньше',
    adjustHint: 'Положительное значение - добавить, отрицательное - вычесть (напр., 100 или -50)',
    multiplier: 'Множитель',
    amount: 'Сумма прибавления/вычитания',
    autoRules: 'Правила авто-выбора',
    enableAutoRules: 'Включить авто-правила',
    ruleType: 'Тип правила',
    none: 'Нет',
    quantity: 'По количеству товаров в корзине',
    paymentMethod: 'По методу оплаты',
    client: 'По клиенту',
    paymentMethodIds: 'ID методов оплаты',
    paymentMethodIdsHint: 'ID методов оплаты через запятую',
    selectRuleTypes: 'Выберите типы правил',
    selectPaymentMethods: 'Выберите методы оплаты',
    cartTotal: 'На основе суммы корзины',
    minCartAmount: 'Минимальная сумма корзины',
    clientRuleHint: 'Вы можете задать предпочитаемый тип цены для клиента при создании/редактировании клиента. Эта цена будет автоматически применена при выборе клиента в новой продаже',
    name: 'Название',
    iconAndText: 'Иконка и текст',
    textUnderIcon: 'Текст под иконкой',
    comission: 'Комиссия',
    category: 'Категория',
    cash: 'Наличные',
    card: 'Безналичные',
    settingsByStore: 'Настройки по филиалам  ',
    destinationWallet: 'Счет зачисления ',
    categorySortHint: 'Порядок категорий сохраняется автоматически. После изменения порядка перезагрузите страницу, либо приложение, чтобы увидеть изменения на странице Новой продажи.',
    // ATL-1892 — перестановка сохраняется одним пакетом: при ошибке не меняется ни одна категория.
    categoryReorderFailed: 'Не удалось сохранить порядок категорий. Ничего не изменилось. Попробуйте ещё раз, а если ошибка повторится, напишите в поддержку.',
    newCategory: 'Новая категория',
    moveToCategory: 'В какую категорию перенести товары с этой категории',
    modifiers: 'Модификаторы товаров',
    onlyOneUnitError: 'Нельзя удалить единственную единицу измерения',
    newUnit: 'Новая единица измерения',
    shortName: 'Короткое обозначение',
    noPriceModificators: 'Нет надбавок или скидок',
    value: 'Значение',
    priceModificatorsHint: 'Можно добавить надбавку или скидку к общему чеку при выборе этого метода покупки, например - процент за обслуживание, налог, скидку за заказ с собой... Укажите положительное либо отрицательное значение в процентах. Если -10, то будет скидка 10 процентов, если 20, то будет надбавка к цене 20 процентов.',
    priceModificators: 'Надбавки и скидки',
    downloadingUpdateHint: 'Скачиваем обновление, приложение вскоре перезагрузится',
    noUpdates: 'Обновлений нет',
    noUpdateForWebError: 'Эта функция для мобильного приложения. Для обновления веб версии перезагрузите страницу',
    commonBetweenStores: 'Общий',
    legal: 'Правовая информация',
    helpCenterLink: 'https://atlas-app.notion.site/745b5f835e9144ecb022d729e6b2e23b?v=ee4205e47e5f4437b943b535f6c41fa4&pvs=4',
    discountInstructions: 'Добавьте опции скидок в процентах для того чтобы они появились в списке доступных скидок в Новой Продаже',
    printSettings: 'Настройки печати',
    invoiceTitle: 'Заголовок накладной',
    invoiceSubtitle: 'Подзаголовок накладной',
    imagesSection: 'Изображения',
    logoImage: 'Логотип',
    additionalImage: 'Дополнительное изображение внизу',
    additionalImageWidth: 'Ширина доп. изображения (px)',
    includeFields: 'Включать поля',
    includeVAT: 'Включать НДС',
    vatRate: 'Ставка НДС (%)',
    additionalText: 'Дополнительный текст внизу',
    signatureFields: 'Подписи',
    removeField: 'Удалить поле',
    imagePositionOptions: {
      'top-left': 'Верхний левый',
      'top-right': 'Верхний правый',
      'bottom-left': 'Нижний левый',
      'bottom-right': 'Нижний правый',
      'none': 'Нет'
    },
    fieldOptions: {
      invoiceNumber: 'Номер накладной',
      date: 'Дата',
      supplier: 'Поставщик',
      buyer: 'Покупатель',
      clientPhone: 'Телефон клиента',
      clientAddress: 'Адрес клиента',
      itemsTable: 'Таблица товаров',
      productImages: 'Изображения товаров',
      totalAmount: 'Общая сумма',
      amountInWords: 'Сумма прописью',
      signatures: 'Подписи',
      qrCode: 'QR код'
    },
    printTemplates: 'Шаблоны печати',
    createTemplate: 'Создать шаблон',
    editTemplate: 'Редактировать шаблон',
    deleteTemplate: 'Удалить шаблон',
    templateName: 'Название шаблона',
    selectStore: 'Выберите филиал',
    pageSize: 'Размер страницы',
    selectPageSize: 'Выберите размер страницы',
    customWidth: 'Ширина (мм)',
    pagePadding: 'Отступы страницы (px)',
    globalTemplate: 'Общий шаблон',
    storeTemplate: 'Шаблон для филиала',
    setAsDefault: 'Установить по умолчанию',
    defaultTemplate: 'Шаблон по умолчанию',
    templateForStore: 'Шаблон для {{storeName}}',
    noTemplates: 'Нет созданных шаблонов',
    createFirstTemplate: 'Создайте первый шаблон',
    confirmDeleteTemplate: 'Удалить шаблон "{{templateName}}"?',
    templateDeleted: 'Шаблон удален',
    templateSaved: 'Шаблон сохранен',
    templateCreated: 'Шаблон создан',
    templateType: 'Тип шаблона',
    templateTypes: {
      sale: 'Продажа',
      supply: 'Поставка',
      supplyOrder: 'Заказ поставки'
    }
  },
  manufactures: {
    manufactures: 'Производство',
    manufacture: 'Производство',
    manufacturedDate: 'Дата производства',
    quantity: 'Количество',
    batchNumber: 'Номер партии',
    batchNumberPlaceholder: 'Необязательно',
    mainHintLink: 'https://www.notion.so/atlas-app/What-is-Manufacture-module-b543d903c7404428809ce7e8d3c06898?pvs=4#1887ceb1e04f80649832eb0955fa9da6',
    mainHintAction: 'Инструкция',
    cashier: 'Кассир',
    ingredientUnitCosts: 'Цены ингредиентов за ед.',
    ingredients: 'Ингредиенты (кол-во x цена = итого)',
    ingredientsCost: 'Общая стоимость ингредиентов',
    manufactureId: 'ID производства',
    productId: 'ID товара',
    ingredientIds: 'Ингредиенты по ID (ID: кол-во на 1 ед. продукции)',
    totalSum: 'Итого',
  },
  spendings: {
    spendings: 'Расходы',
    spending: 'Расход',
    monthlySpendings: 'Ежемесячные расходы',
    newMonthlySpending: 'Новый ежемесячный расход',
    allStores: 'Общее/Другое',
    name: 'Название',
    amount: 'Сумма',
    startDate: 'Дата начала',
    hasEndDate: 'Указать дату окончания',
    endDate: 'Дата окончания',
    typeRecurring: 'Тип - ежемесячный',
    instructions: 'Инструкция по заполнению',
    category: 'Категория',
    type: 'Тип',
    source: 'Источник',
    details: 'Детали',
    adminSpendingCategories: 'Категории расходов для админов',
    spendingCategories: 'Категории расходов для продавцов',
    OPEX: 'Операционные расходы (повседневные)',
    CAPEX: 'Капитальные вложения (большие и необычные - ремонт, покупка оборудования)',
    notANumberError: 'Сумма должна быть числом больше 0',
  },
  shift: {
    shift: 'Смена',
    shiftStats: 'Отчет по сменам',
    deposit: 'Внесение',
    withdrawal: 'Изъятие',
    openShift: 'Открытие смены',
    closeShift: 'Закрытие смены',
    endDayAmount: 'Сумма на конец дня',
    logout: 'Выйти с аккаунта',
    close: 'Закрыть',
    amount: 'Сумма',
    ofdAmountError: 'Суммы в кассе не совпадают с суммами в ОФД',
    ofdSalesNotSentError: 'Найдены неотправленные в ОФД продажи',
    ofdSalesNotMatchError: 'Сумма продаж не совпадает с суммой чеков в ОФД',
    shiftClosed: 'Смена закрыта',
    pleaseOpenShift: 'Откройте пожалуйста смену',
    startCashboxAmount: 'Наличные в кассе на начало смены',
    employeesOnShift: 'Сотрудники в смене',
    open: 'Открыть',
    fullDay: 'Полный день',
    fromTo: 'с {{from}} до {{to}}',
    saving: 'Сохранение...',
    add: 'Добавить',
    workingHours: 'Часы работы',
    shiftInfo: 'Данные по смене',
    shiftOpenedTime: 'Открытие смены',
    shiftClosedTime: 'Закрытие смены',
    cashInCashbox: 'Наличные в кассе',
    startAmount: 'Сумма на начало смены',
    withdrawals: 'Изъятия',
    returns: 'Возвраты',
    sales: 'Продажи',
    spendings: 'Расходы',
    paidSupplies: 'Оплаченные приемки',
    deposits: 'Внесения',
    total: 'Итого',
    salesByEmployees: 'Продажи по сотрудникам',
    getOfdStats: 'Обновить данные ОФД',
    ofdStats: 'Данные ОФД',
    cashSales: 'Продажи наличными',
    cardSales: 'Продажи картой',
    cashReturns: 'Возвраты наличными',
    cardReturns: 'Возвраты картой',
    withdrawalsAndDeposits: 'Изъятие/Внесение',
    newSpending: 'Расход',
    cancelCloseShift: 'Отменить закрытие',
    closeShiftCTA: 'Закрыть смену',
    byCash: 'Наличными',
    openAmountFact: 'Открытие - Факт',
    cashEndAmount: 'Закрытие - Факт',
    systemEndAmount: 'Закрытие - Сколько должно быть',
    shiftNotClosed: 'Смена не была закрыта',
    alreadyClosed: 'Эта смена уже закрыта',
    duplicateOpens: 'Смена открыта повторно ({{count}}): лишние открытия записаны в кассу',
    closedWithoutAmounts: 'Смена закрыта без подсчитанных сумм',
    duplicateCloses: 'Смена закрыта повторно ({{count}}): лишние закрытия записаны в кассу',
    cash: 'Наличные',
    amountShouldBe: 'Сколько должно быть',
    amountFact: 'Факт',
    otherPayments: 'Оплаты переводом и другие',
    today: 'Сегодня',
    previousDays: 'Прошлые даты',
    notANumberError: 'Сумма должна быть числом',
    deleteFailed: 'Не удалось удалить. Попробуйте еще раз',
  },
  transfers: {
    transfers: 'Перемещения',
    transfer: 'Перемещение',
    products: 'Товары',
    inputBarcode: 'Введите штрих-код',
    name: 'Название',
    quantity: 'Количество',
    fromStore: 'Из какого филиала',
    toStore: 'В какой филиал',
    total: 'Итого',
    addThroughBarcodeHint: 'Добавьте товары через поиск либо просканировав штрих-код',
    inStockFromStore: 'Остаток (откуда)',
    inStockToStore: 'Остаток (куда)',
  },
  clientOrders: {
    clientOrders: 'Заказы от клиентов',
    clientOrder: 'Заказ',
    statusNew: 'Новый',
    statusContacted: 'Связались с клиентом, ждем подтверждения',
    statusConfirmed: 'Заказ подтвержден, ожидает доставки', 
    statusDelivered: 'Заказ доставлен',
    statusCanceled: 'Заказ отменен',
    name: 'Имя',
    date: 'Дата',
    phone: 'Телефон',
    deliveryType: 'Метод доставки',
    deliveryAddress: 'Адрес доставки',
    delivery: 'Доставка',
    pickup: 'Самовывоз',
    now: 'Сейчас',
    status: 'Статус',
    processed: 'Обработан',
    notProcessed: 'Активный',
    writeOnWhatsapp: 'Написать на WhatsApp',
    convertIntoSale: 'Оформить продажу',
    noOrders: 'Нет активных заказов',
    showActive: 'Показать только активные',
  },
  payments: {
    paymentStats: 'Деньги / Cash Flow',
    loadError: 'Не удалось загрузить отчёт. Цифры за период не посчитаны — проверьте интернет и попробуйте ещё раз.',
    loadRetry: 'Повторить',
    paymentTransactions: 'Денежные транзакции',
    paymentTransaction: 'Денежная транзакция',
    payments: 'Платежи',
    transactions: 'Операции',
    overview: 'Обзор',
    saleAmount: 'Сумма продаж: ',
    saleAmount_description: 'Это общая стоимость всех продаж, совершенных за выбранный период, без учета того, был ли получен платеж.',
    currentPeriodSalePayments: 'Фактические поступления от продаж за текущий период: ',
    currentPeriodSalePayments_description: 'Эта сумма показывает, сколько денежных средств было получено именно за продажи, которые были совершены в пределах выбранного диапазона дат. Она исключает платежи, полученные за продажи, совершенные до этого периода.',
    totalSalePayments: 'Фактические поступления от продаж: ',
    totalSalePayments_description: 'Это общая сумма денежных средств, фактически поступивших от продаж. Она включает платежи за продажи, совершенные в текущем периоде, а также платежи, полученные в текущем периоде за продажи, совершенные в предыдущих периодах (например, неоплаченный платеж за прошлую продажу).',
    upcomingAccountsReceivable: 'Ожидаемые поступления за неоплаченные продажи: ',
    upcomingAccountsReceivable_description: 'Это общая сумма денег, которую клиенты все еще должны вам за комплексные продажи за все время (как текущие, так и прошлые продажи).',
    complexSales: 'Комплексные продажи',
    unpaidComplexSalesList: 'Неоплаченные комплексные продажи:',
    unpaidSupplies: 'Неоплаченные приемки',
    totalUnpaidSupplies: 'Неоплаченные приемки за весь период: ',
    totalCreditSalesAmountCurrentPeriod: 'Итого продаж за текущий период: ',
    totalCreditSalesPaidAmountCurrentPeriod: 'Итого оплачено за текущий период: ',
    totalCreditSalesPaidAmountPreviousPeriod: 'Итого оплачено за прошлый период: ',
    totalCreditSalesPaidAmount: 'Итого оплачено: ',
    totalAccountsReceivable: 'Ожидаемые платежи: ',
    creditSalesAmount: 'Сумма продаж: ',
    creditSalesPaidAmount: 'Сумма оплат: ',
    accountsReceivable: 'Ожидаемые поступления: ',
    currentPeriodPayments: 'Фактические расходы за текущий период: ',
    currentPeriodPayments_description: 'Это сумма всех денежных средств, которые были потрачены бизнесом на различные расходы (зарплаты, платежи поставщикам, регулярные расходы, прочие расходы, банковские комиссии) в течение выбранного периода.',
    currentBalance: 'Баланс: ',
    currentBalance_description: 'Это ваша операционная прибыль или убыток за выбранный период на основе фактических денежных поступлений и расходов. Показывает разницу между денежными средствами, полученными от фактических доходов текущего периода, и общими фактическими расходами, оплаченными в текущем периоде.',
    upcomingPayments: 'Предстоящие расходы за текущий период: ',
    upcomingPayments_description: 'Это общая сумма денег, которую бизнес еще должен выплатить по возникшим расходам (зарплаты, поставки, регулярные расходы), которые еще не были оплачены в текущем периоде. Считается отдельно по каждому сотруднику, поставщику и регулярному расходу: переплата одному получателю не уменьшает долг перед другими. Учитывается только начисленное за выбранный период — долги и авансы по зарплате за прошлые периоды («Баланс за все время» в разделе «Зарплаты») и неоплаченные приемки прошлых периодов («Неоплаченные приемки за весь период» в разделе «Поставщики») сюда не входят.',
    upcomingBalanceCurrentPeriod: 'Ожидаемый баланс за текущий период: ',
    upcomingBalanceCurrentPeriod_description: 'Это ваш прогнозируемый денежный баланс, если все ожидаемые поступления от клиентов (по всем продажам) будут получены и все предстоящие платежи по расходам за текущий период будут произведены.',
    previousPeriodPayments: 'Фактические расходы за прошлые периоды: ',
    previousPeriodPayments_description: 'Это общая сумма денежных средств, выплаченных в течение текущего выбранного периода по расходам, которые фактически возникли в предыдущих периодах (например, оплата приемки поставщика за прошлый месяц).',
    upcomingBalanceWithPreviousPeriodPayments: 'Баланс с учетом расходов за прошлый и будущий периоды: ',
    upcomingBalanceWithPreviousPeriodPayments_description: 'Это прогнозируемый баланс, учитывающая текущий баланс, все предстоящие платежи и поступления, а также за минусом платежей, относящимся к прошлым и будущим периодам.',
    paymentsForCurrentPeriodSales: "Платежи по продажам за текущий период: ",
    paymentsForPreviousPeriodSales: "Платежи по продажам за предыдущий период: ",
    futurePeriodPayments_description: 'Это общая сумма денежных средств, выплаченных в течение текущего выбранного периода по расходам, которые возникнут в будущих периодах (например, оплата аренды за следующий месяц).',
    salaries: 'Зарплаты',
    totalDebit: 'Начислено: ',
    totalCredit: 'Выплачено в общем: ',
    totalCreditPreviousPeriod: 'Выплачено за прошлый период: ',
    totalCreditCurrentPeriod: 'Выплачено за текущий период: ',
    balance: 'Баланс за текущий период: ',
    allTimeBalance: 'Баланс за все время: ',
    currentPeriodBalance: 'Баланс за текущий период: ',
    currentPeriod: 'Текущий период',
    pay: 'Выплатить',
    suppliers: 'Поставщики',
    suppliersTotalDebit: 'Принято товаров в текущем периоде: ',
    monthlySpendings: 'Ежемесячные расходы',
    otherPayments: 'Другие расходы',
    spendingPayments: 'Разовые расходы: ',
    bankPercent: 'Комиссия банка: ',
    cashboxShiftDifference: 'Разница в закрытиях смен: ',
    salaryPayment: 'Выплата зарплаты',
    workingHourPayment: 'Выплата зарплаты',
    supplyPayment: 'Оплата поставщикам',
    recurringSpendingPayment: 'Оплата ежемесячных расходов',
    spendingPayment: 'Оплата расходов',
    // ATL-987 — see the note on the English key.
    returnPayment: 'Возврат денег покупателю',
    category: 'Категория',
    destination: 'Кому',
    amount: 'Сумма',
    sourceWallet: 'Источник',
    paymentDate: 'Дата оплаты',
    paymentRange: 'Период за который идет оплата',
    details: 'Детали',
    supplyPaymentRangeInfo: 'Все приемки до этой даты включительно будут помечены оплачеными',
    stats: 'Отчет',
    byCreatedDate: 'По дате создания',
    byPaymentPeriod: 'По периоду оплаты',
    totalPaymentAmount: 'Общая сумма платежей: ',
    todayEmptyPayments: 'Сегодня не было платежей',
    futurePeriodPayments: 'Фактические платежи за будущие периоды: ',
    totalCreditFuturePeriod: 'Выплачено за будущий период: ',
    foundError: 'Нашли ошибку в отчете?',
    foundErrorDescription: 'Выберите сотрудника и нажмите пересчитать, чтобы пересчитать баланс сотрудника за все время',
    recalculate: 'Пересчитать',
  },
  complexSales: {
    complexSales: 'Комплексные продажи',
    complexSale: 'Комплексная продажа',
    addProduct: 'Поиск товаров/услуг',
    addEmptyRow: 'Добавить пустую строку',
    totalPurchaseSum: 'Итого себестоимость',
    totalSaleSum: 'Итого стоимость',
    expectedMargin: 'Маржинальность',
    paymentMethod: 'Метод оплаты',
    commentText: 'Комментарий',
    expectedProfit: 'Ожидаемая прибыль',
    itemsList: 'Список расходов',
    emptyItems: 'Нет расходов. Добавьте расходы через Поиск из базы товаров/услуг или вручную через пустую строку',
    name: 'Название',
    salePrice: 'Цена',
    purchasePrice: 'Себестоимость',
    packagePrice: 'Доп расходы',
    quantity: 'Количество',
    itemsTotals: 'Итого по товарам/услугам',
    templates: 'Шаблоны',
    finalPrice: 'Стоимость для клиента',
    emptyTemplate: 'Пустой шаблон',
    editTemplate: 'Редактирование шаблона',
    newTemplate: 'Новый шаблон',
    editComplexSale: 'Редактирование комплексной продажи',
    newComplexSale: 'Новая комплексная продажа',
    showActive: 'Показать только активные',
    add: 'Добавить',
    newComment: 'Новый комментарий',
    new: 'Новый',
    inProgress: 'В работе',
    finished: 'Завершен',
    canceled: 'Отменен',
    template: 'Шаблон',
    createdDate: 'Дата создания',
    client: 'Клиент',
    status: 'Статус',
    comments: 'Комментарии',
    dateAndAuthor: 'Дата/автор',
    comment: 'Комментарий',
    deletedAuthor: 'Удален',
    payments: 'Оплаты',
    newPayment: 'Новая оплата',
    amount: 'Сумма',
    description: 'Описание',
    totalPaid: 'Всего оплачено',
    remainingAmount: 'Остаток к оплате',
    includeSales: 'Включить простые продажи',
  },
  printStickers: {
    printStickers: 'Печать этикеток',
    addProductSticker: 'Добавить товар',
    printSettings: 'Настройки этикетки',
    worksOnWebError: 'Печать этикеток пока доступна только с компьютера',
    stickerDate: 'Дата на этикетке',
    products: 'Товары',
    weight: 'Вес',
    preview: 'Предпросмотр',
    stickerSettings: 'Настройки этикетки',
    printStickersCTA: 'Распечатать этикетки',
    stickerHeight: 'Высота этикетки',
    generalFontSize: 'Общий размер шрифта',
    priceFontSize: 'Размер шрифта цены',
    printDateOnSticker: 'Печетать дату на этикетке',
    print: 'Печетать',
    doNotPrint: 'Не печатать',
    stickerHeightHint: '150 для бумаги высотой 40мм, 113 для 30мм',
    additionalPricesToShow: 'Дополнительные цены на этикетках',
    additionalPricesToShowHint: 'Выберите какие дополнительные типы цен должны отображаться на этикетках. Будут показаны только те цены, которые настроены для товаров.',
    printFailed: 'Не удалось напечатать этикетки. Проверьте принтер и попробуйте снова.',
    nothingToPrint: 'Нет этикеток для печати.',
  },
  profile: {
    profile: 'Профиль',
    chooseStore: 'Выбрать филиал',
    email: 'Email',
    logout: 'Выйти с аккаунта'
  },
  salary: {
    salary: 'Зарплата',
    periodMissing: 'Период не указан',
    chooseSameMonthError: 'Выберите даты только в одном месяце',
    fromToHours: 'с {{start}} до {{end}}',
    employee: 'Сотрудник',
    salaryType: 'Тип зарплаты',
    bonusType: 'Тип бонусов',
    withoutBonuses: 'Без бонусов',
    hoursQuantity: 'Часы работы в текущем периоде',
    daysQuantity: 'Количество дней работы в текущем периоде',
    monthlySales: 'Продажи за текущий период (минус возвраты)',
    salaryAccrued: 'Зарплата начислено за текущий период',
    salaryPaid: 'Зарплата выплачено за текущий период',
    allTimeSalaryCredited: 'Всего начислено за все время',
    allTimeSalaryPaid: 'Всего выплачено за все время',
    allTimeBalance: 'Баланс за все время',
    salesPlan: 'План продаж',
    baseline: 'Базовая цель',
    bonus: 'бонусов',
    factSales: 'Фактические продажи за {{count}} дня/дней',
    tillBaseline: 'До базовой цели',
    daily: 'в день',
    until: 'До',
    bonuses: 'Бонусы',
    workingHours: 'Часы работы',
    amount: 'Сумма',
    noDataForMonth: 'Нет данных за месяц',
    payouts: 'Выплаты',
    currentPeriodBalance: 'Баланс за текущий период',
    foundError: 'Нашли ошибку в отчете?',
    foundErrorDescription: 'Нажмите кнопку пересчета, чтобы пересчитать баланс сотрудника',
    recalculate: 'Пересчитать',
  },
  checklist: {
    checklist: 'Чеклист',
    shift: 'Смена',
    openShift: 'Открыть смену',
    wipeTheWindows: 'Протереть витрину',
    washTheFloor: 'Помыть полы',
    cleaning: 'Уборка',
    checklistNotAvailableForToday: 'Поменяйте дату на вчера и попробуйте заново',
    addTask: 'Добавить задачу',
    editTask: 'Редактировать задачу',
    type: 'Тип',
    oneTimeTask: 'Разовая задача',
    dailyTask: 'Ежедневная задача',
    section: 'Раздел',
    positionBefore: 'Расположение (перед)',
  },
  updates: {
    updates: 'Обновления',
    deleteProduct: 'Удаление товара',
    newProduct: 'Создание товара',
    updateProductPrices: 'Изменение цены товара',
    deleteSale: 'Удаление продажи',
    deleteWorkingHour: 'Удаление со смены',
    purchasePrice: 'Закупочная',
    unknownDate: 'дата неизвестна',
  },
  operations: {
    totalSum: 'Общая сумма: {{totalSum}}',
    filterUnavailable: 'Не удалось применить фильтр списка — данные не показаны, чтобы не показать неверные цифры. Обновите приложение или обратитесь в поддержку.'
  },
  marketingLists: {
    marketingLists: 'Рассылки',
    marketingList: 'Рассылка',
    createMarketingList: 'Новая рассылка',
    chooseProduct: 'Выбрать товар',
    byProductCategory: 'По категории товара',
    byProduct: 'По товару',
    saveList: 'Сохранить список',
    writeOnWhatsapp: 'Написать на WhatsApp',
    status: 'Статус',
    completed: 'Завершено',
    notCompleted: 'Не завершено',
    complete: 'Завершить',
  },
  stats: {
    stats: 'Отчеты',
    productStats: 'Отчет по товарам',
    productsToday: 'Товары за сегодня',
    receipts: 'Чеки',
    quantityShort: 'Кол-во',
    amount: 'Сумма',
    marginShort: 'Маржа',
    today: 'Сегодня',
    name: 'Название',
    category: 'Категория',
    supplier: 'Поставщик',
    sales: 'Продажи',
    salesMargin: 'Маржа от продаж',
    loyalClients: 'Лояльные клиенты',
    returns: 'Возвраты',
    supplies: 'Приемки',
    writeOffs: 'Списания',
    salaryAmount: 'ЗП за день',
    spendings: 'Расходы',
    inStockProducts: 'Товары в наличии',
    monthlySpendings: 'Ежемесячные расходы',
    profitForDay: '~ Прибыль за день',
    saleQuantity: 'Продажи кол-во',
    saleAmount: 'Продажи сумма',
    writeOffQuantity: 'Списания кол-во',
    writeOffAmount: 'Списания сумма',
    supplyQuantity: 'Приемки кол-во',
    supplyAmount: 'Приемки сумма',
    margin: 'Маржинальность',
    profit: 'Прибыль',
    checkQuantity: 'Чеки кол-во',
    purchaseAmount: 'Себестоимость сумма',
    packageAmount: 'Себестоимость упаковки',
    columns: 'Колонки',
    byProductCategory: 'По категориям товаров',
    bySupplier: 'По поставщикам',
    byProduct: 'По товарам',
    foundError: 'Нашли ошибку в отчете?',
    foundErrorDescription: 'Такое возможно из-за нестабильного интернет соединения. Выберите дату с какого момента началась ошибка.',
    recalculate: 'Пересчитать',
    pAndL: 'Прибыль / P&L',
    noCategory: 'Без категории',
    netProductSales: 'Продажи (Net Product Sales)',
    costOfSales: 'Себестоимость товаров (Cost of Sales)',
    paidByBonuses: 'Оплачено бонусами',
    grossIncome: 'Маржа (Gross Income)',
    writeOffRevisionReturnsAmount: 'Возвраты, списания, недосдачи',
    revisionDifferenceAmount: 'Разница в ревизиях',
    cashboxDifferenceAmount: 'Разница в закрытиях смен',
    salary: 'Зарплаты',
    bankPercent: 'Комиссия банка',
    netIncome: 'Операционная прибыль (Net Income)',
    capexSpendings: 'Капитальные вложения',
    pureProfit: 'Чистая прибыль',
    transfers: 'Перемещения',
    startProductAmount: 'Стоимость товаров на начало',
    endProductAmount: 'Стоимость товаров на конец',
    productAmountDifference: 'Разница в стоимости товаров',
    // ATL-1123 — snapshots of stock are per store per day; when one is absent the opening or
    // closing valuation cannot be computed, and must not be shown as 0 ₸.
    stockSnapshotUnavailable: 'нет данных',
    stockSnapshotsMissing: 'Остатки не сохранены за {{count}} д./магазинов — стоимость товаров не рассчитана',
    stockSnapshotsMissingOpening: 'Остатки не сохранены за {{count}} д./магазинов — стоимость товаров на начало не рассчитана',
    stockSnapshotsMissingClosing: 'Остатки не сохранены за {{count}} д./магазинов — стоимость товаров на конец не рассчитана',
    stockSnapshotsUnreadable: 'Остатки на начало и конец периода не удалось прочитать — стоимость товаров не рассчитана',
    stockSnapshotUnknownCells: 'Остатки неизвестны по {{count}} позициям — стоимость товаров занижена на их величину',
    stockDifferenceNotComparable: 'Из них {{count}} учтены только на одной границе периода — разница посчитана по разным наборам товаров, ей нельзя доверять',
    groupBy: 'Группировать по',
    byPaymentMethod: 'По методу оплаты',
    byPurchaseMethod: 'По методу покупки',
    byEmployee: 'По сотруднику',
    returnQuantity: 'Количество возвратов',
    salesAverageAmount: 'Средний чек',
    saleQuantityFull: 'Количество продаж',
    salesStats: 'Отчет по продажам',
    fullPeriod: 'За весь период',
    byDays: 'По дням',
    salesStatsDescription: 'Продажи по дням и методам оплат',
    allStats: 'Все отчеты',
    profitStats: 'Прибыль / P&L',
    profitStatsDescription: 'Отчет о прибылях и убытках',
    paymentStats: 'Деньги / Cash flow',
    paymentStatsDescription: 'Отчет о движении денег',
    shiftStats: 'Отчет по сменам',
    shiftStatsDescription: 'Информация о прошлых сменах и недосдачах',
    productStatsDescription: 'Какие товары и категории продаются лучше всего',
    writeOffStats: 'Отчет по списаниям',
    writeOffStatsDescription: 'Какие товары и категории списываются больше всего',
    revisionStats: 'Отчет по ревизиям',
    revisionStatsDescription: 'Консолидированный отчет по ревизиям',
  },
  // {t('stats.')}
  clients: {
    clients: 'Клиенты',
    client: 'Клиент',
    name: 'Имя',
    phone: 'Телефон',
    address: 'Адрес',
    bonusValue: 'Бонусы',
    bonusLevel: 'Уровень бонусов',
    loyaltyDiscount: 'Постоянная скидка',
    punchCard: 'Карта лояльности',
    preferredPriceType: 'Предпочитаемый тип цены',
    none: 'Нет',
    salesValue: 'Всего покупок: {{salesQuantity}} на сумму {{salesSum}}',
    profitValue: 'Всего прибыли: {{profit}}',
    averageSalesFrequency: 'Средняя частота покупок - каждые {{value}} дней(-я)',
    addingBonuses: 'Начисление бонусов',
    purchases: 'Покупки',
    clientNotFoundShowingSnapshot: 'Клиент не найден (возможно, удалён) — показаны данные из продажи',
    clientRefreshFailed: 'Не удалось обновить данные клиента — показаны данные из продажи',
    noClientPurchases: 'У клиента пока нет покупок',
    purchasesLoadError: 'Не удалось загрузить покупки клиента. Закройте карточку и откройте её снова.',
    operationsLoadError: 'Не удалось загрузить историю операций клиента.',
    topProducts: 'Топ продукты (чеки, кол-во, сумма)',
    addBonuses: 'Начислить бонусы',
    phoneAndName: 'Телефон или имя',
    lastPurchaseDate: 'Выберите период последней покупки',
    registrationDate: 'Выберите период регистрации',
    searchClients: 'Поиск клиентов',
    byPhoneAndName: 'По номеру телефона или имени',
    byProducts: 'По купленным товарам',
    byLastPurchaseDate: 'По последней дате покупки',
    byRegistrationDate: 'По дате регистрации',
    count: 'Количество - {{count}}',
    writeOnWhatsapp: 'Написать на WhatsApp',
    manualBonusChange: 'Ручное изменение бонусов',
    operations: 'Операции',
    allClients: 'Все клиенты',
    editClient: 'Редактирование клиента',
    invalidPhoneNumber: 'Неверный формат номера телефона',
    saving: 'Сохранение...',
    updateSuccess: 'Клиент успешно обновлен. Изменения отобразятся через минуту.',
    clientStats: 'Статистика клиентов',
    totalClients: 'Всего клиентов',
    newClients: 'Новые клиенты',
    activeClients: 'Активные клиенты',
    last7Days: 'Последние 7 дней',
    last30Days: 'Последние 30 дней',
    thisWeek: 'Эта неделя',
    thisMonth: 'Этот месяц',
  },
  login: {
    // WA-ONBOARD-001 — согласие на сообщения в WhatsApp, под полем телефона при регистрации.
    // Формулировка закреплена тестом utils/__tests__/whatsappOnboardingConsent.test.js:
    // должна называть WhatsApp и Atlas, объяснять, зачем сообщения, и как отписаться.
    whatsappOptIn: 'Присылайте мне помощь по настройке Atlas в WhatsApp - советы, как запустить магазин.',
    whatsappOptInDisclosure: 'Напишем на указанный выше номер. Чтобы отписаться, в любой момент ответьте СТОП.',
    login: 'Вход',
    signUp: 'Регистрация',
    newOrgSignUp: 'Регистрация новой компании',
    passwordReset: 'Восстановление пароля',
    email: 'Email',
    password: 'Пароль',
    resetPassword: 'Сбросить пароль',
    resetPasswordSuccess: 'Письмо со сбросом пароля отправлено на почту. Если оно не пришло, проверьте, пожалуйста, папку Спам. Ссылка на сброс пароля действительна на 10 минут',
    loginCTA: 'Войти',
    emailRequired: 'Введите email',
    passwordRequired: 'Введите пароль',
    userNotFound: 'Пользователь не найден',
    wrongPassword: 'Неверный пароль',
    invalidEmail: 'Некорректный email',
    tooManyRequests: 'Слишком много запросов. Попробуйте позже',
    userDisabled: 'Пользователь заблокирован',
    networkRequestFailed: 'Интернет недоступен',
    validateEmailError: 'Введите корректный email',
    passwordLengthError: 'Пароль должен быть не менее 6 символов',
    phoneLengthError: 'Введите корректный номер телефона',
    userInfo: 'Данные пользователя',
    name: 'Имя',
    phone: 'Телефон',
    orgInfo: 'Данные организации',
    orgName: 'Название организации',
    currency: 'Валюта',
    businessType: 'Категория бизнеса',
    fillInOtherBusinessType: 'Введите другую категорию бизнеса',
    clientType: 'Категория ваших клиентов',
    employeeCount: 'Количество сотрудников',
    branchCount: 'Количество ваших филиалов / точек продаж',
    goalOfd: 'Онлайн-касса и интеграция с ОФД',
    goalAccounting: 'Вести бухгалтерию',
    goalInvoicing: 'Выставлять счета, акты',
    goalDocuments: 'Вести документооборот',
    goalTodo: 'Вести список задач по компании',
    goalNone: 'Никакие из вышеперечисленных',
    priorExperienceNo: 'Не вели учет',
    priorExperiencePaper: 'Вели учет в тетради',
    priorExperienceExcel: 'Excel / другие таблицы',
    priorExperienceSpecific: 'Отраслевые решения для автоматизации (для магазинов/ресторанов/производств)',
    priorExperience1c: '1с и другие учетные системы',
    setupOptionNo: 'Я люблю разбираться сам(а), мне не нужна помощь',
    setupOptionPartial: 'Я попробую разобраться сам(а), но помощь не помешает',
    setupOptionFull: 'Я не хочу разбираться сам(а), нужна помощь с настройкой',
    trafficSourceSocial: 'Инстаграмм / Facebook / Соц. сети',
    trafficSourceYoutube: 'Youtube',
    trafficSourceWebSearch: 'Поиск в Google и других поисковых системах',
    trafficSourceAppstore: 'Наткнулся(ась) в App Store / Google Play',
    trafficSourceRecommendation: 'Рекомендация от знакомых',
    trafficSourceOther: 'Другое',
    shopOffline: 'Магазин',
    delivery: 'Доставка',
    admin: 'Админ',
    cashier: 'Продавец',
    universalModifiers: 'Универсальные модификаторы',
    testProduct: 'Тестовый товар',
    adminSpendingCategory1: 'Ремонт и обслуживание',
    adminSpendingCategory2: 'Онлайн реклама',
    spendingCategory1: 'Пакеты',
    spendingCategory2: 'Вода, чай, сахар...',
    recurringSpending1: 'Аренда',
    writeOffReasonWasted: 'Испорчено',
    writeOffReasonInternalUse: 'На нужды компании',
    writeOffReasonGift: 'В подарок клиентам',
    returnReasonMistake: 'Купили по ошибке',
    returnReasonNotLike: 'Не понравился товар',
    returnReasonBadGood: 'Товар испорчен',
    checklistHeader1: 'Уборка',
    checklistHeader2: 'Смена',
    checklistTask1: 'Протереть витрину',
    checklistTask2: 'Помыть полы',
    checklistTask3: 'Открыть смену в кассе',
    goalsAndSettings: 'Цели и настройки',
    goals: 'Цели',
    priorExperienceQuestion: 'Как вы ранее вели учет',
    setupOptionQuestion: 'Нужна ли вам помошь с настройкой приложения',
    trafficSourceQuestion: 'И последний вопрос - откуда вы про нас узнали ☺️',
    register: 'Зарегистрироваться',
  },
  onboarding: {
    registration: 'Регистрация',
    registrationDescription: '',
    sale: 'Провести тестовую продажу',
    saleDescription: 'Для этого закройте данный попап, в главном меню выберите модуль Новая продажа -> Добавить товар, выбрать метод оплаты -> Нажать Готово',
    complexSale: 'Провести тестовую комплексную продажу',
    complexSaleDescription: 'Комплексные продажи актуальны для бизнесов, которые занимаются продажей сложных услуг. Их продажи часто отличаются своей ценой и расходами, в отличие от продаж стандартных товаров и общепита. Например - производство кастомного изделия, разработка сайтов, юридическая услуга... Для этого закройте данный попап, в главном меню выберите модуль Комплексные продажи -> Плюсик в правом верхнем угулу -> Добавить пустую строку -> Заполните остальные поля, выбрать метод оплаты -> Нажать Готово',
    saleReport: 'Увидеть изменения в отчетах по продажам',
    saleReportDescription: 'После совершения продажи, вы можете заметить что цифры сверху на главном меню обновились. Далее вы можете уже посмотреть свой первый отчет по продажам. Для этого зайдите в Главное меню -> Отчеты -> Отчеты по продажам.',
    productStock: 'Увидеть изменения в Остатках товаров',
    productStockDescription: 'После совершения продажи, вы можете заметить что количество товара стало меньше. Для этого зайдите в Главное меню -> Остатки товаров. Так как в начале количество товара было 0 оно ушло в минус за счет продажи.',
    saleHistory: 'Посмотреть Историю продаж и удалить продажу',
    saleHistoryDescription: 'Также совершенную продажу вы можете увидеть в Истории продаж. Там же ее можно сразу удалить. Для этого зайдите в Главное меню -> История продаж -> Выберите продажу -> Возврат -> Удалить',
    complexSaleHistory: 'Посмотреть Историю продаж и удалить продажу',
    complexSaleHistoryDescription: 'Также совершенную продажу вы можете увидеть в списке Комплексных продаж. Там же ее можно сразу удалить. Для этого зайдите в Главное меню -> Комплексные продажи -> Выберите продажу -> Удалить',
    createProduct: 'Создать свои товары',
    createProductDescription: 'Для этого зайдите в Главное меню -> Товары, услуги и ингредиенты -> Нажмите на плюсик в правом верхнем углу. Заполните поля и нажмите сохранить. Вы можете прочитать инструкцию по созданию и описания полей по ссылке в верхней части окна.',
    createSupply: 'Создать приемку',
    createSupplyDescription: 'После создания товара вы можете сделать его приемку. Приемка увеличит количество товара в Остатках товара. Для создания приемки зайдите в Главное меню -> Приемки и нажмите на плюсик в правом верхнем углу. Заполните поля и нажмите сохранить. Вы можете прочитать инструкцию по созданию и описания полей по ссылке в верхней части окна.',
    createSpending: 'Добавить расход',
    createSpendingDescription: 'В ATLAS помимо продаж и остатков товаров вы можете вести свои расходы. Вы можете либо добавить ежемесячные расходы в Настройках -> Ежемесячные расходы. Либо создавать разовые расходы через Главное меню -> Расходы -> Плюсик в правом верхнем углу.',
    profitReport: 'Посмотреть Отчет по прибыли',
    profitReportDescription: 'Главный отчет для которого мы ведем учет в бизнесе. Тут аггрегируются все ваши данные, введеные в приложение. Расчитываются все ваши доходы, расходы за период и рассчитывается автоматически ваша прибыль.',
    viewModules: 'Изучить все доступные модули ATLAS',
    viewModulesDescription: 'Помимо тех модулей, которые вы видите на главной странице есть еще другие, но они на данный момент выключены. Чтобы посомтреть все модули и включить их зайдите в Главное меню -> Настройки организации -> Включите модули и нажмите сохранить.',
    viewHelp: 'Посмотреть справочный центр',
    viewHelpDescription: 'Если у вас еще остались вопросы вы можете изучить Справочный центр либо связаться с поддержкой. Для этого ниже этого чеклиста есть специальные кнопки.',
    viewWeb: 'Зайти в веб версию для компьютеров',
    viewWebDescription: 'ATLAS также доступен с компьютера через любой браузер по ссылке atlas-app.org. Вы можете работать одновременно с любых устройств, все будет синхронизировано в реальном времени. В браузерной версии вы можете дополнительно поключить сканер штрих кодов и принтеры печати чеков.',
    clickOnQuestionToGetStarted: 'Нажмите на знак вопроса для начала работы',
  },
  welcome: {
    header1: 'Супер приложение для вашего бизнеса',
    text1: 'Продажи, остатки товаров, расходы, зарплаты, программа лояльности... Ведите учет всех аспектов вашего бизнеса в одном удобном приложении.',
    header2: 'Подходит для любого бизнеса',
    text2: 'Магазины, кофейни, пекарни, инстаграм продажи, производства... Продаете вы товары или оказываете услуги, работаете с физ лицами либо b2b - настраивайте приложение под себя.',
    header3: 'Доступно с любого устройства',
    text3: 'Веб и мобильные приложения - используйте на компьютере, телефоне, айпаде и любом планшете.',
    header4: 'Анализируйте данные',
    text4: 'Смотрите отчеты в одном месте, приложение автоматически считает все данные и формирует удобные отчеты.',
    header5: 'Работайте в команде',
    text5: 'Пригласите свою команду и будьте в курсе всего, что происходит в вашем бизнесе. Обновление данных в реальном времени на каждом устройстве. Гибкая ролевая система.',
  },
  organizationDetails: {
    retail: 'Магазины / бутики / торговые точки',
    restaurant: 'Кафе / рестораны / кофейни / на вынос',
    online: 'Онлайн торговля',
    manufacture: 'Производство / цеха',
    suppliers: 'Дистрибьюторы / поставщики',
    services: 'Услуги',
    other: 'Другое',
    b2c: 'Только физические лица (b2c)',
    b2b: 'Только компании (b2b)',
    'b2b>b2c': 'И физические лица и компании, но больше компании',
    'b2c>b2b': 'И физические лица и компании, но больше физические лица',
    'b2c&b2b': 'И физические лица и компании',
    '0': 'Нет сотрудников',
    '1-5': '1-5',
    '5-20': '5-20',
    '20-50': '20-50',
    '50+': 'Более 50',
    salesText: 'Простые продажи',
    complexSalesText: 'Комплексные продажи',
    spendingsText: 'Расходы',
    shiftText: 'Смена',
    stockText: 'Остатки товаров',
    suppliesText: 'Приемки',
    writeOffsText: 'Списания',
    revisionsText: 'Ревизии',
    transfersText: 'Перемещения',
    salaryText: 'Зарплата',
    checklistText: 'Чеклист',
    ecommerceText: 'Онлайн каталог и заказы',
    updatesText: 'Обновления',
    paymentsText: 'Платежи',
    printStickersText: 'Печать этикеток',
    manufacturesText: 'Производство',
    clientsText: 'Клиенты и Программа лояльности',
    salesLink: 'https://atlas-app.notion.site/94b264a6d378489dad3ef681d679af82',
    complexSalesLink: 'https://atlas-app.notion.site/2fa413068a3c4cd29b4646b437cdbf5f',
    spendingsLink: 'https://atlas-app.notion.site/577d6dbf02aa4c4ab51a48b029bf0038',
    shiftLink: 'https://atlas-app.notion.site/fb5bb12a8edb4210b1712d9eb103515b',
    stockLink: 'https://atlas-app.notion.site/15479a3a4c5941ea81283658a1a7183d',
    suppliesLink: 'https://atlas-app.notion.site/9956e87ae47b404c85a995d8f4f09456',
    writeOffsLink: 'https://atlas-app.notion.site/8d3afa9a60944231a7061ea4add436a4',
    revisionsLink: 'https://atlas-app.notion.site/7cf86210f8054035ae8906a63a135d41',
    transfersLink: 'https://atlas-app.notion.site/fe86dd9a659b46e389baadeb304550f9',
    salaryLink: 'https://atlas-app.notion.site/9a89871ffe844ef385adecd8e9898322',
    checklistLink: 'https://atlas-app.notion.site/e600dd8d172f4955a3462cab61ad8bb5',
    ecommerceLink: 'https://atlas-app.notion.site/37c3ac79d75847b99fe2aed713701924',
    updatesLink: 'https://atlas-app.notion.site/c5f1807c38504e51b036dd06268eb8fc',
    paymentsLink: 'https://atlas-app.notion.site/c49dc592f2304232831e48a2f401e676',
    printStickersLink: 'https://atlas-app.notion.site/4444f23cc8b34917b4637e7ebc7416fa',
    manufacturesLink: 'https://atlas-app.notion.site/b543d903c7404428809ce7e8d3c06898',
    clientsLink: 'https://atlas-app.notion.site/5c89d17429434438a5455a21f229e7d4',
    salesDescription: 'В Продажах вы можете совершать простые продажи и смотреть историю продаж. Подходит для магазинов, общепита, дистрибьюторов, стандартных услуг и простых производств',
    complexSalesDescription: 'В Комплексных продажах можно вести продажи, состоящих из нескольких товаров, услуг, расходов с возможностью задачи суммы продажии вручную. Также реализован функционал статусов и подсчета рентабельности продажи. Подходит для тех, кто продает кастомные услуги и производства.',
    spendingsDescription: 'В Расходах можно вести учет ваших нерегулярных расходов.',
    shiftDescription: 'Смены нужны для удобства работы с наличными в кассе и для контроля сменных сотрудников. С ними удобно понимать были ли недосдачи в деньгах за эту смену.',
    stockDescription: 'В Остатках товаров можно смотреть актуальное количество товара в наличии, если вы ведете учет остатков товаров.',
    suppliesDescription: 'В Приемках можно вести учет приемок/поставок товаров или ингредиентов от ваших поставщиков. Что в каком количестве вы получили от кого и когда.',
    writeOffsDescription: 'В Списаниях можно вести учет списанных товаров или ингредиентов. К примеру если они испортились или пришли в нетоварный вид или просто вы кому-то подарили.',
    revisionsDescription: 'В Ревизиях можно вести учет ревизий товаров - это когда вы пересчитываете актуальное количество товара и сравниваете с количеством сколько должно быть по системе.',
    transfersDescription: 'В Перемещениях можно фиксировать передвижения товаров из одного филиала/склада в другой.',
    salaryDescription: 'В Зарплатах вы можете вести учет времени работы сменных сотрудников и автоматически рассчитывать их зарплату в зависимости от отработанного времени.',
    checklistDescription: 'Чеклисты - это список дел для ваших сотрудников на каждый день, где они могут отмечать что во сколько сделали.',
    ecommerceDescription: 'Вы можете создать онлайн-каталог в один клик и получать оттуда заказы. После включения нужно дополнительно настроить в Настройки -> Настройки маркетплейс.',
    updatesDescription: 'В Обновлениях собраны обновления по организации - изменения цен, удаленные продажи - чтобы все были в курсе.',
    paymentsDescription: 'В Платежах можно вести учет платежей поставщикам, выплаты зарплаты сотрудникам, выплат по ежемесячным расходам. И смотреть по итогу очень полезный отчет по движению денег',
    printStickersDescription: 'В Печати этикеток можно печатать этикетки со штрих кодами. Доступно только в браузерной версии на компьютере.',
    manufacturesDescription: 'В Производстве можно вести учет произведенных товарово - если к примеру вы печету выпечку или вышиваете одежду из разных ингредиентов/материалов',
    clientsDescription: 'В Клиентах можно вести учет клиентов, указывать их в продажах и подключить программу лояльности. После включения нужно дополнительно настроить программу лояльности в Настройки -> Настройки Программы лояльности.',
    nanErrorText: 'Количество знаков после запятой должно быть числом',
    decimalPlacesErrorText: 'Количество знаков после запятой должно быть от 0 до 5',
    name: 'Название',
    currency: 'Валюта',
    currencyDecimalPlaces: 'Количество знаков после запятой в ценах',
    enabledModules: 'Используемые модули',
    moreInfo: ' Подробнее',
    deleteOrg: 'Удалить организацию и аккаунт',
    deleteOrgConfirmationText: 'Пожалуйста подтвердите удаление вашего аккаунта и организации с ATLAS. Все ваши данные будут удалены без возможности восстановления.',
    email: 'Email',
    password: 'Пароль',
    delete: 'Удалить',
    resetStocks: 'Обнулить остатки',
    resetData: 'Сбросить данные',
    resetDataDescription: 'Выберите какие данные сбросить и укажите диапазон дат. Это действие нельзя отменить.',
    resetSelectedData: 'Сбросить выбранные данные',
    confirmResetData: 'Подтвердить сброс данных',
    confirmResetDataDescription: 'Вы собираетесь сбросить следующие данные. Это действие нельзя отменить.',
    confirmReset: 'Подтвердить сброс',
    operations: 'Операции',
    // Reset operations descriptions
    salesResetDescription: 'Сбросить все данные о продажах включая простые продажи и историю продаж.',
    complexSalesResetDescription: 'Сбросить все данные о комплексных продажах включая кастомные услуги и продажи производства.',
    suppliesResetDescription: 'Сбросить все данные о поступлениях и поставках.',
    writeOffsResetDescription: 'Сбросить все данные о списаниях включая испорченные или поврежденные товары.',
    transfersResetDescription: 'Сбросить все данные о перемещениях между магазинами/складами.',
    spendingsResetDescription: 'Сбросить все данные о расходах и записях расходов.',
    revisionsResetDescription: 'Сбросить все данные о ревизиях товаров.',
    manufacturesResetDescription: 'Сбросить все записи о производстве.',
    productStockResetDescription: 'Обнулить все количества товаров на складе и удалить историю движений.',
    resetDataBeforeDate: 'Сбросить данные до даты',
    warning: 'Предупреждение',
    resetDataWarning: 'Это действие навсегда удалит все данные до выбранной даты (данные с самой выбранной даты не будут удалены). Это действие нельзя отменить.',
    whatWillBeDeleted: 'Что будет удалено:',
    beforeDate: 'до',
    dailyStats: 'Ежедневная статистика',
    monthlyStats: 'Ежемесячная статистика',
    dailyProductReports: 'Ежедневные отчеты по товарам',
    transactions: 'Транзакции',
    productStockSnapshots: 'Снимки остатков товаров',
    orders: 'Заказы',
    movementData: 'Данные о движении товаров',
    allProductStocks: 'Все остатки товаров (обнулить)',
    allProducts: 'Все товары (удалить полностью)',
    resetAllData: 'Сбросить все данные',
    additionalOptions: 'Дополнительные опции',
    resetProductStocks: 'Сбросить остатки товаров',
    resetProductStocksDescription: 'Обнулить все количества товаров на складе',
    deleteAllProducts: 'Удалить все товары',
    deleteAllProductsDescription: 'Навсегда удалить все товары из организации',
    adminRequired: 'Требуется доступ администратора',
    adminRequiredDescription: 'Только администраторы могут выполнять операции сброса данных. Обратитесь к администратору, если вам нужно сбросить данные.',
    adminRequiredError: 'Только администраторы могут выполнять операции сброса данных.',
  },
  productsAndIngredients: {
    productsAndIngredients: 'Товары, услуги и ингредиенты',
    new: 'Новый',
    barcodeAlreadyUsed: 'Штрих код уже используется в товаре - ',
    copy: 'Копия + ',
    copyMadeToast: 'Копия создана, отредактируйте поля и сохраните',
    makeACopy: 'Создать копию',
    instructions: 'Инструкция по заполнению',
    general: 'Общие',
    name: 'Название',
    namePlaceholder: 'Молоко 1л',
    status: 'Статус',
    enabled: 'Включен',
    forItem: ' для {{item}}',
    productType: 'Тип товара',
    product: 'Товар',
    service: 'Услуга',
    priceTypes: 'Категории и правила ценообразования',
    advancedPricing: 'Расширенное ценообразование',
    noPriceTypesConfigured: 'Типы цен не настроены. Пожалуйста настройте типы цен в настройках.',
    price: 'Цена',
    copyFromFirst: 'Скопировать из первого',
    priceTypesHint: 'Настройте типы цен в Настройках для добавления дополнительных опций ценообразования.',
    autoCalculated: 'Рассчитывается автоматически',
    hideInNewSaleScreen: 'Скрывать на экране Новой продажи (для ингредиентов)',
    hideInNewSaleScreenShort: 'Скрыть в Новой продаже',
    additionalPrices: 'Дополнительные цены',
    additionalPricesHint: 'Опциональные дополнительные цены (опт, рассрочка и т.д.). Базовая цена задается выше в поле Цена продажи.',
    configureInSettings: 'Настройте дополнительные типы цен в Настройках → Категории и правила ценообразования',
    organizationWide: 'Общая цена на всю организацию',
    perStore: 'Отдельные цены по филиалам',
    composite: 'Составной',
    manufactureType: 'Тип производства',
    manufacturedBeforeSale: 'Товар нужно произвести заранее (пример - хлеб, вы сможете следить за остатками произведенного товара)',
    manufacturedDuringSale: 'Товар производится во время продажи (пример - капучино, количество в наличии произведенного товара будет всегда 0)',
    purchasePrice: 'Закупочная цена',
    additionalSpendingsToPurchasePrice: 'Доп расходы к закупочной цене (расходы на этикетку, упаковку)',
    additionalSpendingsToPurchasePriceShort: 'Доп расходы',
    salePrice: 'Цена продажи ',
    category: 'Категория',
    supplier: 'Поставщик',
    productUnit: 'Единица измерения',
    productUnits: 'Единицы измерения',
    barcode: 'Штрихкод',
    addAdditionalBarcode: 'Добавить еще один штрихкод',
    forProductStocks: 'Для Остатков товаров',
    inStockQuantity: 'Количество товара в наличии ',
    showStocksinFloat: 'Показывать остатки нецелыми числами',
    floatNumbers: 'Нецелые числа',
    showInImportantProducts: 'Показывать в важных товарах',
    show: 'Показывать',
    quantityToHighlightRed: 'Количество при котором нужно подсветить красным',
    forLoyaltyProgram: 'Для программы лояльности',
    punchCardParticipation: 'Участвует в программе N-ый напиток бесплатно',
    participates: 'Участвует',
    forEcommerce: 'Для интернет магазина',
    activeInEcommerce: 'Доступен в интернет магазине',
    oldPrice: 'Старая цена (для акции)',
    tags: 'Тэги',
    defaultQuantity: 'Дефолтный вес',
    photos: 'Фото',
    takePhoto: 'Снять фото',
    chooseFromGallery: 'Выбрать с галереи',
    showDisabledProducts: 'Показать выключеные товары',
    nameEmptyError: 'Пожалуйста заполните поле Название',
    categoryEmptyError: 'Пожалуйста заполните поле Категория',
    supplierEmptyError: 'Пожалуйста заполните поле Поставщик',
    productUnitEmptyError: 'Пожалуйста заполните поле Единица измерения',
    imageStillUploadingError: 'Пожалуйста подождите пока загрузится изображение',
    salePricesEmptyError: 'Пожалуйста заполните поле Цена продажи',
    purchasePriceEmptyError: 'Пожалуйста заполните поле Закупочная цена',
    compositeNoIngredientsError: 'Составные продукты должны иметь хотя бы один ингредиент в составе',
    productUsedAsIngredientError: 'Невозможно удалить товар, используемый в качестве ингредиента в других товарах. Сначала удалите его как ингредиент в других товарах: {{products}}.',
    usedAsIngredient: 'Используется в качестве ингредиента в:',
    editedItems: "Изменено товаров - {{count}}",
    visibleFields: "Включенные поля",
    filters: "Фильтры",
    batchEdit: 'Массовое редактирование',
    exportImport: 'Экспорт/Импорт',
  }, 
  home: {
    salesForToday: 'Продажи\nна сегодня',
    numberOfChecks: 'Количество\nчеков',
    averageCheck: 'Средний\nчек',
    upgradePromptText: 'Перейдите на более высокий тариф для увеличения лимитов.',
    upgrade: 'Перейти',
  },
  billing: {
    id: 'ID',
    plan: 'Тариф',
    price: 'Цена',
    status: 'Статус',
    subscriptions: 'Подписки',
    past_due: 'Оплата просрочена',
    paused: 'Приостановлена',
    deleted: 'Отменен',
    deletedPaymentFailed: 'Не продлён — оплата не прошла',
    active: 'Активен',
    undefined: 'Бесплатный',
    purchaseDate: 'Дата покупки',
    paidTill: 'Оплачено до',
    restorePurchases: 'Восстановить покупки с App Store',
    billingSuccessReload: 'Оплата прошла успешно. Пожалуйста перезагрузите страницу, ваш тариф обновится в течении минуты',
    continueOnWeb: 'Пожалуйста зайдите с веб версии ATLAS для продолжения (https://atlas-app.org)',
    continueOnIos: 'Пожалуйста зайдите с iOS версии ATLAS для продолжения',
    organizationName: 'Организация: {{orgName}}',
    currentPlan: 'Текущий тариф: {{currentPlan}}', 
    planStatus: 'Статус тарифа: {{planStatus}}',
    monthlySalesUSD: 'Продажи за месяц: ~${{monthlySalesUSD}}',
    webHintRussia: 'Есть проблемы с оплатой для обладателей Российских карт. Альтернативный способ оплаты описан по ссылке.',
    androidBillingDisabled: 'Оплата через Android не поддерживается. Пожалуйста используйте веб версию ATLAS для управления подпиской (https://atlas-app.org)',
    iosHintRussia: 'Инструкция оплаты для региона Россия в App Store описана по ссылке.',
    manageSubscription: 'Управлять подпиской',
    cancelSubscription: 'Отменить подписку',
    updatePaymentMethod: 'Обновить способ оплаты',
    changePlan: 'Сменить тариф',
    perMonth: '/месяц',
    buy: 'Купить',
    noPurchases: 'У вас нет покупок',
    sourceRevenuecat: 'Куплен через App Store',
    sourcePaddle: 'Куплен через веб',
    subscriptionManagedByRevenuecatError: 'Подписка управляется через App Store. Пожалуйста используйте iOS приложение для управления подпиской',
    cancelSurveyTitle: 'Почему вы отменяете подписку?',
    cancelSurveyText: 'Мы хотели бы знать причину, чтобы улучшить наш сервис.',
    selectReason: 'Выберите причину',
    confirmCancel: 'Подтвердить отмену',
    selectCancelReason: 'Пожалуйста, выберите причину отмены',
    cancelReasonTooExpensive: 'Слишком дорого',
    cancelReasonMissingFeatures: 'Не хватает нужных функций',
    cancelReasonNotUsing: 'Недостаточно используем сервис',
    cancelReasonBugs: 'Слишком много ошибок/проблем',
    cancelReasonOther: 'Другая причина',
    cancelReasonFoundBetter: 'Нашли альтернативу',
    cancelReasonBusinessClosing: 'Бизнес закрывается/закрылся',
    cancelReasonOtherPlan: 'Переключение на другой тариф',
  },
  pricingPlans: {
    freeName: 'Бесплатный',
    freeDescription: 'Только для начинающих предпринимателей - ваши продажи менее $1000 в месяц',
    tier1Name: 'Тариф 1',
    tier1Description:  'Ваши продажи в месяц до $10 000',
    tier2Name: 'Тариф 2',
    tier2Description: 'Ваши продажи в месяц от $10 000 до $20 000',
    tier3Name: 'Тариф 3',
    tier3Description: 'Ваши продажи в месяц от $20 000 до $50 000',
  },
  paywall: {
    title: 'ATLAS Business',
    subtitle: 'Самая удобная учетная система для 1000+ малых бизнесов со всего мира',
    cta: 'Продолжить',
    popular: 'ПОПУЛЯРНЫЙ',
    seeOtherPlans: 'Посмотреть другие планы',
    perMonthAfterTrial: '/месяц после 14-дневного пробного периода',
    salesMonthly: ' продаж в месяц',
    users: ' пользователя(-ей)',
    branches: ' филиал(-а)',
    modules: 'Модули',
    support: 'Поддержка',
  },
  reviews: {
    reviewName1: 'Магазин косметики',
    reviewText1: 'Отличное приложение, буду рекомендовать',
    reviewName2: 'Кофейня с собой',
    reviewText2: 'Спасибо огромное за такую прекрасную программу, для нашего бизнеса самое то',
    reviewName3: 'Дистрибьютор кофе',
    reviewText3: 'Я сейчас уже 5 срм даю попробовать сотрудникам, сотрудники сказали что ваше предложение очень удобное',
    reviewName4: 'Сервис велосипедов',
    reviewText4: 'Шикарно, мне кажется, для небольших организаций или самозанятых, да или вообще для тех кто оказывает услуги-это будет супер актуальное приложение',
    reviewName5: 'Мебель на заказ',
    reviewText5: 'Всё понятно и доступно. Спасибо за полезную программу. Функции комлексных продаж ни у кого больше не видел',
  },
  funnel: {
    continue: 'Продолжить',
    chooseYourPrimaryGoal: 'Какая у вас основная цель?',
    increaseSales: 'Увеличить продажи',
    reduceCosts: 'Уменьшить расходы',
    improveOperations: 'Упорядочить операционку',
    choseAtlas: '1000+',
    choseAtlasDescription: 'малых бизнесов со всего мира используют ATLAS для управления своим бизнесом',
    chooseYourBusinessType: 'Какой у вас тип бизнеса?',
    retail: 'Магазины / бутики / торговые точки',
    restaurant: 'Кафе / рестораны / кофейни / на вынос',
    online: 'Интернет-торговля',
    manufacture: 'Производство / мастерские',
    suppliers: 'Дистрибьюторы / поставщики',
    services: 'Услуги',
    construction: 'Строительство',
    other: 'Другое',
    chooseYourClientType: 'Какой у вас тип клиентов?',
    b2c: 'Только физические лица (b2c)',
    b2b: 'Только компании (b2b)',
    'b2b>b2c': 'И физические лица и компании, но больше компании',
    'b2c>b2b': 'И физические лица и компании, но больше физические лица',
    'b2c&b2b': 'И физические лица и компании',
    chooseYourCurrency: 'Какую валюту вы используете?',
    '0': 'Нет сотрудников',
    '1-5': '1-5',
    '5-20': '5-20',
    '20-50': '20-50',
    '50+': 'Более 50',
    doYouHaveBranches: 'У вас есть филиалы?',
    'no': 'Нет',
    'yes': 'Да',
    branchCount: 'Сколько у вас филиалов?',
    employeeCount: 'Сколько у вас сотрудников?',
    chooseAdditionalFeatures: 'Какие дополнительные функции вам интересны?',
    yourPriorExeperience: 'Как вы вели учет ранее?',
    setupOptions: 'Нужна ли вам помощь с настройкой?',
    trafficSource: 'Откуда вы о нас узнали?',  
    orgName: 'Как называется ваша организация?',
    userName: 'Как вас зовут?',
    userPhone: 'Какой у вас телефон?',
    userEmail: 'Какой у вас электронный адрес?',
    userPassword: 'Укажите пароль',
    creatingOrg: 'Спасибо за ответы, настраиваем вашу организацию',
    profitabilityTitle: 'А вы знали?',
    clientTrackingTitle: 'Хотите вести учет клиентов?',
    clientTrackingDescription: 'Atlas поможет вам легко вести учет клиентов и вознаграждать их лояльность.',
    profitabilityDescription: 'Бизнесы, которые правильно ведут учет финансов и товаров, в 3 раза чаще становятся прибыльными. Atlas поможет вам легко управлять и тем и другим.',
    loyaltyProgramTitle: 'Вы хотите включить программу лояльности?',
    loyaltyProgramDescription: 'Выберите какую программу лояльности вы хотите использовать:',
    loyaltyTypeNone: 'Не сейчас - настрою позже',
    loyaltyTypeCashback: 'Бонусная программа - Возвращайте % с каждой покупки бонусами',
    loyaltyTypePunchCard: 'Накопительные карты - Каждый N-й товар бесплатно (отлично для кофеен!)',
    cashbackLevelTitle: 'Выберите процент кэшбэка',
    cashbackLevelDescription: 'Сколько % от суммы покупки клиенты будут получать бонусами?',
    bonusLevel: '{{percent}}% с каждой покупки',
    punchCardCapacityTitle: 'Выберите количество покупок для бесплатного товара',
    punchCardCapacityDescription: 'Сколько покупок должен сделать клиент, чтобы получить товар бесплатно? Будут участвовать только те товары, которые вы добавите в программу лояльности',
    punchCardCapacity: 'Каждый {{count}}-й товар бесплатно',
    onlineCatalogTitle: 'Хотите создать онлайн-каталог?',
    onlineCatalogDescription: 'Atlas может автоматически создать онлайн-каталог ваших товаров, которым вы сможете делиться с клиентами',
    salesReportsTitle: 'Какие отчеты вы хотели бы получать?',
    salesReportsDescription: 'Выберите все подходящие варианты:',
    salesReportsOverall: 'Продажи по дням и неделям',
    salesReportsByProduct: 'Самые популярные товары',
    salesReportsByEmployee: 'Продажи по сотрудникам',
    salesReportsWithProfit: 'Прибыль и убытки за месяц',
    salesReportsSpendings: 'Отчет по расходам',
    monthlySalesVolume: 'Какой у вас приблизительный объем продаж в месяц?',
    inventorySize: 'Сколько различных товаров/услуг вы предлагаете?',
    inventoryLess50: 'Менее 50',
    inventory50to200: '50 - 200',
    inventory200to1000: '200 - 1000',
    inventoryMore1000: 'Более 1000',
    salesVolumeLess1k: 'Менее $1000',
    salesVolume1kTo10k: '$1000 - $10,000',
    salesVolume10kTo20k: '$10,000 - $20,000',
    salesVolume20kTo50k: '$20,000 - $50,000',
    salesVolumeMore50k: 'Более $50,000',
    inventoryTrackingQuestion: 'Как вы хотите вести учет товаров?',
    inventoryTrackingNone: 'Не нужно',
    inventoryTrackingBasic: 'Базовый учет (только количества)',
    inventoryTrackingAdvanced: 'Продвинутый учет (с отрицательным остатком, алертами и несколькими складами)',
    inventoryOperationsQuestion: 'Какие операции с товарами вам нужны?',
    inventoryOperationsSupplies: 'Учет поставщиков/закупок',
    inventoryOperationsWriteOffs: 'Учет списаний/брака',
    inventoryOperationsTransfers: 'Перемещение между филиалами',
    inventoryOperationsRevisions: 'Регулярные инвентаризации/пересчеты',
    inventoryOperationsManufacture: 'Производство/сборка продуктов',
    barcodeQuestion: 'Хотите использовать штрихкоды?',
    barcodeNo: 'Нет',
    barcodeYesOwn: 'Да, у нас свои штрихкоды',
    barcodeYesSupplier: 'Да, используем штрихкоды поставщиков',
    barcodeWantToStart: 'Хотим начать использовать штрихкоды',
    analysisTitle: 'Анализируем ваши ответы...',
    analysisDescription: 'Настраиваем Atlas под потребности вашего бизнеса',
    reviewName1: 'Владелец кофейни',
    reviewText1: 'Atlas помог нам увеличить выручку на 23% всего за 3 месяца за счет лучшего контроля остатков и уменьшения списаний',
    reviewName2: 'Управляющий бутика',
    reviewText2: 'Программа лояльности просто супер! Клиентам нравится, и они возвращаются снова',
    reviewName3: 'Сеть ресторанов',
    reviewText3: 'Управлять несколькими точками стало намного проще. Отчеты помогают принимать правильные решения',
    reviewName4: 'Интернет-магазин',
    reviewText4: 'Функция онлайн-каталога сэкономила нам кучу времени. Теперь клиентам удобно просматривать товары',
    reviewName5: 'Небольшой магазин',
    reviewText5: 'Идеально для малого бизнеса. Просто в использовании и есть все необходимое',
  },
  exportImport: {
    exportImport: 'Экспорт/Импорт',
    ignore: 'Пропустить/Не импортировать',
    name: 'Наименование',
    price: 'Цена',
    purchasePrice: 'Закупочная цена',
    barcode: 'Штрихкод',
    category: 'Категория',
    supplier: 'Поставщик',
    inStock: 'В наличии',
    externalId: 'ID',
    clientExport: 'Экспорт клиентов',
    exportClientsHint: 'Экспорт всех данных о клиентах в формате CSV или Excel',
    generateClientExportCSV: 'Экспорт клиентов в CSV',
    generateClientExportExcel: 'Экспорт клиентов в Excel',
    phone: 'Телефон',
    totalPurchasedValue: 'Сумма покупок',
    registrationDate: 'Дата регистрации',
    lastPurchaseDate: 'Дата последней покупки',
    bonusValue: 'Сумма бонусов',
    productExport: 'Экспорт продуктов',
    generateProductExportCSV: 'Экспорт продуктов в CSV',
    generateProductExportExcel: 'Экспорт продуктов в Excel',
    importProducts: 'Импорт продуктов',
    other: 'Другое',
    pcs: 'шт',
    yes: 'да',
    uploadProducts: 'Загрузить товары',
    previewImport: 'Предпросмотр импортируемых данных',
    mapColumns: 'Сопоставьте поля товара с импортированными столбцами',
    column: 'Столбец',
    selectField: 'Выберите поле',
    confirmImport: 'Подтвердить импорт',
    dropFileHere: 'Перетащите CSV файл сюда',
    releaseToUpload: 'Отпустите для загрузки',
    dragAndDropHint: 'Перетащите CSV файл сюда или нажмите для выбора',
    next: 'Далее',
    import: 'Импортировать',
    mapCategories: 'Сопоставьте импортированные категории с уже существующими в ATLAS',
    mapSuppliers: 'Сопоставьте импортированных поставщиков с уже существующими в ATLAS',
    createNewCategory: 'Создать новую категорию',
    createNewSupplier: 'Создать нового поставщика',
    updateExistingProductsSettings: 'Обновить существующие товары',
    updateExistingProductsSettingsHint: 'Если в ATLAS уже есть товары с таким ID или штрихкодом - нужно ли их обновить данными из импортируемого файла?',
    update: 'Обновить',
    doNotUpdate: 'Не обновлять',
    requiredColumnsMissing: 'Колонки название, цена и закупочная цена обязательны',
    totalRows: 'Всего строк: {{count}}',
    importDone: 'Импорт завершен!',
    importProgress: 'Прогресс импорта: {{count}} of {{totalCount}}',
    importError: 'Ошибка импорта: {{error}}',
    importProductsHint: 'Вы можете импортировать товары из CSV файла. Файл должен содержать следующие колонки: название, цена, закупочная цена, штрихкод, категория, поставщик, остаток. Первая строка файла должна содержать названия колонок.',
    exportProductsHint: 'Вы можете экспортировать товары в CSV/Excel файл. Файл будет содержать следующие колонки: название, цена, закупочная цена, штрихкод, категория, поставщик, остаток. Первая строка файла будет содержать названия колонок.',
  },
  salesImport: {
    title: 'Импорт продаж',
    openImporter: 'Перейти к импорту продаж',
    hint: 'Импорт продаж из файла .xlsx, .csv или .tsv. Одна строка — один проданный товар: артикул, количество, клиент (телефон) и дата. Строки с одинаковым клиентом и датой можно объединить в один заказ. Импортированные продажи списывают остатки и попадают в отчёты так же, как обычные продажи, поэтому перед импортом покажем сводку.',
    article: 'Артикул',
    quantity: 'Количество',
    date: 'Дата',
    client: 'Клиент (телефон)',
    paymentMethod: 'Способ оплаты',
    ignore: 'Пропустить/Не импортировать',
    uploadSales: 'Загрузить файл продаж',
    dropFileHere: 'Перетащите файл сюда',
    dragAndDropHint: 'Перетащите файл .xlsx, .csv или .tsv сюда, либо нажмите для выбора',
    readError: 'Не удалось прочитать файл: {{error}}',
    unsupportedFile: 'Неподдерживаемый файл. Нужен .xlsx, .xls, .csv или .tsv',
    emptyFile: 'В файле нет данных: нужна строка заголовков и хотя бы одна строка с продажей',
    previewImport: 'Предпросмотр файла',
    totalRows: 'Всего строк: {{count}}',
    mapColumns: 'Сопоставьте колонки',
    selectField: 'Выберите колонку',
    requiredColumnsMissing: 'Не заполнены обязательные колонки: {{columns}}',
    next: 'Далее',
    store: 'Магазин',
    storeRequired: 'Выберите магазин',
    grouping: 'Объединение строк',
    groupingHint: 'Если включено, строки с одинаковым клиентом и датой станут одним заказом. Строки без клиента никогда не объединяются — каждая станет отдельной продажей.',
    joinByClientAndDate: 'Объединять клиент + дата в один заказ',
    defaultPaymentMethod: 'Способ оплаты по умолчанию',
    defaultPaymentMethodHint: 'Применяется к строкам без колонки оплаты или с неизвестным значением. «В долг» — продажа без оплаты: деньги на кошелёк не поступают.',
    selectPaymentMethod: 'Выберите способ оплаты',
    paymentMethodRequired: 'Выберите способ оплаты по умолчанию',
    postPaid: 'В долг (без оплаты)',
    mapClients: 'Клиенты',
    mapClientsHint: 'Клиенты ищутся по номеру телефона. Для ненайденных выберите: создать нового клиента или импортировать продажу без клиента.',
    searchingClients: 'Ищем клиентов по номерам телефонов...',
    clientFound: 'Найден: {{name}}',
    clientLookupFailed: 'Поиск не удался — выберите вариант вручную',
    createClient: 'Создать клиента',
    withoutClient: 'Без клиента',
    summary: 'Проверьте перед импортом',
    summaryOrders: 'Будет создано заказов: {{count}}',
    summaryRows: 'Строк товаров: {{count}}',
    summaryClients: 'Заказов с клиентом: {{count}}',
    ordersPreview: 'Что будет создано',
    summaryTotal: 'Сумма продаж: {{total}}',
    negativeStockWarning: 'После импорта остаток станет отрицательным:',
    negativeStockRow: '{{name}}: остаток {{inStock}}, продаётся {{quantity}} → {{resulting}}',
    invalidRows: 'Строк с ошибками: {{count}}',
    invalidRow: 'Строка {{row}}: {{reason}}',
    invalidRowWithValue: 'Строка {{row}}: {{reason}} — «{{value}}»',
    andMore: '...и ещё {{count}}',
skipInvalidRows: 'Пропустить строки с ошибками и импортировать остальные',
    downloadIssues: 'Скачать отчёт об ошибках',
    import: 'Импортировать {{count}} заказов',
    importProgress: 'Импортируем {{count}} из {{totalCount}}...',
    importError: 'Ошибка импорта: {{error}}',
    done: 'Импорт завершён',
    doneOrders: 'Создано заказов: {{count}}',
    doneRows: 'Импортировано строк: {{count}}',
    failedOrders: 'Не удалось создать заказов: {{count}}',
    failedOrder: 'Строки {{rows}}: {{reason}}',
    importAnotherFile: 'Импортировать другой файл',
    reportRow: 'Строка',
    reportStatus: 'Статус',
    reportReason: 'Причина',
    reportValue: 'Значение',
    reportSkipped: 'Пропущена',
    reportFailed: 'Ошибка при импорте',
    error: {
      MISSING_ARTICLE: 'Не указан артикул',
      MISSING_QUANTITY: 'Не указано количество',
      INVALID_QUANTITY: 'Количество должно быть числом больше нуля',
      MISSING_DATE: 'Не указана дата',
      INVALID_DATE: 'Не удалось распознать дату — ожидается 31.12.2026 или 2026-12-31',
      PRODUCT_NOT_FOUND: 'Товар с таким артикулом не найден',
    },
  },
  manufactureImport: {
    title: 'Импорт производства',
    openImporter: 'Перейти к импорту производства',
    hint: 'Импорт производств из одного или нескольких файлов .xlsx, .csv или .tsv. Одна строка — одно производство по рецепту товара (дата, товар, количество, партия), либо одна строка ингредиента: строки с одинаковым «№ производства» в одном файле — одно производство, и их ингредиенты заменяют рецепт. Импортированное производство меняет остатки и попадает в отчёты так же, как созданное вручную, поэтому перед импортом покажем сводку.',
    uploadFiles: 'Загрузить файлы производства',
    addMoreFiles: 'Добавить ещё файлы',
    dropFilesHere: 'Перетащите файлы сюда',
    dragAndDropHint: 'Перетащите один или несколько файлов .xlsx, .csv или .tsv сюда, либо нажмите для выбора',
    unsupportedFile: 'Неподдерживаемый файл. Нужен .xlsx, .xls, .csv или .tsv',
    readingFiles: 'Читаем файлы...',
    filesTitle: 'Файлы ({{count}})',
    fileRows: 'строк с данными: {{count}}',
    fileUnreadable: 'не удалось прочитать: {{error}}',
    clearFiles: 'Убрать все файлы',
    noReadableFile: 'Ни один файл не удалось прочитать — нечего сопоставлять',
    next: 'Далее',
    back: 'Назад',
    mapColumns: 'Сопоставьте колонки',
    mapColumnsHint: 'Колонки выбираются по первому файлу ({{file}}) и применяются ко всем файлам по названию заголовка. Файл, в котором нет выбранной колонки, будет пропущен целиком и попадёт в отчёт.',
    selectColumn: 'Выберите колонку',
    ignore: 'Не импортировать',
    options: 'Параметры импорта',
    store: 'Магазин',
    includeDuplicates: 'Импортировать вероятные дубли',
    includeDuplicatesHint: 'Вероятный дубль — производство, которое уже есть в Atlas: тот же товар, тот же рабочий день магазина и то же количество, а номера партий не противоречат друг другу: совпадают или хотя бы у одного из них партия не указана. По умолчанию такие производства пропускаются, чтобы повторный импорт файла не удвоил остатки.',
    loadingExisting: 'Проверяем существующие производства и ревизии...',
    loadError: 'Не удалось загрузить существующие производства или ревизии: {{error}}',
    summary: 'Проверьте перед импортом',
    summaryFiles: 'Файлов принято: {{accepted}}, отклонено: {{rejected}}',
    summaryPrepared: 'Производств в файлах: {{count}}',
    summaryToImport: 'Будет создано производств: {{count}}',
    summarySkippedDuplicates: 'Будет пропущено вероятных дублей: {{count}}',
    summaryDuplicates: 'Вероятных дублей: {{count}}',
    summaryTwins: 'Одинаковых производств внутри файлов: {{count}} (будут созданы все)',
    summaryTotalCost: 'Себестоимость создаваемых производств: {{total}}',
    lastHandEntered: 'Последнее производство, введённое вручную, в этом магазине: {{date}}',
    lastHandEnteredNone: 'Производств, введённых вручную, в этом магазине с {{date}} нет',
    lastRevision: 'Последняя ревизия в этом магазине: {{date}}',
    lastRevisionNone: 'Ревизий в этом магазине с {{date}} нет',
    revisionWarning: 'Производств, которые могли быть до последней ревизии: {{count}} — с временем раньше ревизии или, если время в файле не указано, в рабочий день ревизии и раньше. Ревизия могла уже учесть их в остатках — импорт изменит остатки ещё раз. Решите, импортировать ли их, убрать из файла или провести ревизию после импорта.',
    costPriceNote: 'Себестоимость считается по текущим закупочным ценам ингредиентов, как и при ручном вводе.',
    manufacturesPreview: 'Что будет создано',
    rowQuantity: 'кол-во {{quantity}}',
    rowBatch: 'партия {{batch}}',
    rowIngredients: 'ингредиентов: {{count}}',
    rowCost: 'себестоимость {{total}}',
    badge: {
      duplicate: 'вероятный дубль',
      twin: 'одинаковое производство в файлах',
      beforeRevision: 'возможно, до последней ревизии',
      skipped: 'будет пропущено',
    },
    invalidRows: 'Ошибок: {{count}} — эти строки и файлы не будут импортированы',
    andMore: '...и ещё {{count}}',
    downloadReport: 'Скачать отчёт',
    import: 'Импортировать производств: {{count}}',
    importProgress: 'Импортируем {{count}} из {{totalCount}}...',
    importError: 'Ошибка импорта: {{error}}',
    done: 'Импорт завершён',
    doneCreated: 'Создано производств: {{count}}',
    doneSkipped: 'Пропущено вероятных дублей: {{count}}',
    doneFailed: 'Не удалось создать: {{count}}',
    doneErrors: 'Не импортировано из-за ошибок в файлах: {{count}}',
    importMore: 'Импортировать другие файлы',
    failure: {
      INGREDIENT_NOT_FOUND: 'Ингредиент «{{ingredient}}» товара «{{product}}» не найден в каталоге — производство не создано',
    },
    report: {
      file: 'Файл',
      rows: 'Строки',
      product: 'Товар',
      date: 'Дата',
      quantity: 'Количество',
      batch: 'Партия',
      status: 'Статус',
      reason: 'Причина / примечание',
      statusRejected: 'Пропущена (ошибка)',
      statusSkippedDuplicate: 'Пропущено (вероятный дубль)',
      statusPlanned: 'Будет создано',
      statusCreated: 'Создано',
      statusFailed: 'Ошибка при импорте',
    },
    field: {
      date: 'Дата',
      product: 'Товар (артикул/штрихкод)',
      quantity: 'Количество',
      batch: 'Партия',
      manufactureNo: '№ производства',
      ingredient: 'Ингредиент (артикул/штрихкод)',
      ingredientPerUnit: 'Расход на 1 ед.',
    },
    mismatchField: {
      date: 'дата',
      product: 'товар',
      quantity: 'количество',
      batch: 'партия',
      ingredient: 'ингредиент указан не во всех строках',
    },
    error: {
      MISSING_DATE: 'Не указана дата',
      INVALID_DATE: 'Не удалось распознать дату — ожидается 31.12.2026 или 2026-12-31',
      MISSING_PRODUCT: 'Не указан товар',
      MISSING_QUANTITY: 'Не указано количество',
      INVALID_QUANTITY: 'Количество должно быть числом больше нуля',
      QUANTITY_NOT_STORABLE: 'Количество: не больше 4 знаков после запятой и меньше 1 000 000',
      BATCH_TOO_LONG: 'Номер партии длиннее 100 символов',
      INGREDIENT_WITHOUT_NUMBER: 'Ингредиент указан без «№ производства»',
      MISSING_PER_UNIT: 'Не указан расход ингредиента на 1 ед.',
      INVALID_PER_UNIT: 'Расход на 1 ед. должен быть числом больше нуля',
      PRODUCT_NOT_FOUND: 'Товар не найден',
      INGREDIENT_NOT_FOUND: 'Ингредиент не найден',
      AMBIGUOUS_PRODUCT: 'Подходит несколько товаров — укажите артикул или штрихкод, который есть только у одного',
      AMBIGUOUS_INGREDIENT: 'Подходит несколько товаров-ингредиентов — укажите артикул или штрихкод, который есть только у одного',
      PRODUCT_NOT_COMPOSITE: 'Товар не составной — производить можно только товар с ингредиентами',
      EMPTY_RECIPE: 'У товара пустой рецепт — добавьте ингредиенты товару или укажите их в файле',
      INVALID_RECIPE: 'В рецепте товара у ингредиента не указано количество или оно не больше нуля — исправьте рецепт товара или укажите ингредиенты в файле',
      GROUP_MISMATCH: 'Строки одного «№ производства» расходятся: {{fields}}',
      DUPLICATE_INGREDIENT: 'Ингредиент повторяется в одном производстве',
      FILE_UNREADABLE: 'Не удалось прочитать файл',
      FILE_COLUMNS_MISSING: 'В файле нет выбранных колонок — файл пропущен',
      FILE_EMPTY: 'В файле нет строк с данными',
      FILE_DUPLICATE_NAME: 'Файл с таким именем уже добавлен — пропущен (№ производства и строки отчёта привязаны к имени файла)',
      MAPPING_REQUIRED_MISSING: 'Не выбрана колонка «{{field}}»',
      MAPPING_INGREDIENT_INCOMPLETE: 'Выбрана колонка ингредиента — нужна и колонка «{{field}}»',
      MAPPING_COLUMN_REUSED: 'Колонка для «{{field}}» уже выбрана для другого поля',
      STORE_REQUIRED: 'Выберите магазин',
    },
  },
  supplyOrders: {
    supplyOrders: 'Заказы поставщикам',
    supplyOrder: 'Заказ поставщику',
    showActive: 'Показать активные',
    completed: 'Исполнен',
    notCompleted: 'Не исполнен',
    status: 'Статус',
    statusDraft: 'Черновик',
    statusSent: 'Заказан',
    statusCancelled: 'Отменен',
    statusCompleted: 'Исполнен',
    name: 'Наименование',
    currentQuantity: 'Текущий остаток',
    weeklySales: 'Продажи за неделю',
    weeklyWriteoffs: 'Списания за неделю',
    orderQuantity: 'Количество на заказ',
    items: 'Товары',
    totalPrice: 'Сумма заказа',
    totalSum: 'Сумма заказа',
    threshold: 'Порог низкого остатка',
    exportPDF: 'Экспорт в PDF',
    exportText: 'Копировать как текст',
    createSupply: 'Создать приемку',
    orderDate: 'Дата заказа',
    dateUnreadable: 'Не удалось прочитать дату заказа — сохранение отключено, чтобы не перезаписать её',
    linesUnreadable: 'Не удалось прочитать часть позиций заказа — сохранение и экспорт отключены, чтобы они не потерялись',
    noActiveOrders: 'Нет активных заказов',
    createNew: 'Создать новый заказ',
  },
  loyaltySettings: {
    cashbackName: 'Накопительная система бонусов (Кэшбэк)',
    enabled: 'Включен',
    defaultBonusLevel: 'Стартовый процент кэшбэка у клиентов',
    punchCardName: 'N-й напиток/товар в подарок',
    punchCardCapacity: 'Какой по счету товар будет бесплатным',
  },
  marketplaceSettings: {
    linkName: 'Онлайн-каталог по ссылке',
    enabled: 'Включен',
    providedLink: 'Ваша ссылка на онлайн-каталог - ',
    copy: 'Скопировать',
    marketplaceName: 'Доступен в общем маркетплейсе ATLAS',
    description: 'Описание компании и товаров',
    storeForMarketplace: 'С какого филиала брать цены/доступность товаров',
    separateStoreForMarketplace: 'Если вы хотите вести отдельно доступность и цены товаров в маркетплейсе - заведите новый филиал и укажите его тут',
    go: 'Перейти',
    stores: 'Филиалы',
    disableNotInStockProducts: 'Выключать для заказа товары, которых нет в наличии',
    enabledCategories: 'Доступные категории товаров в маркетплейсе',
    priceTypesForMarketplace: 'Доступные типы цен в маркетплейсе',
  },
  stores: {
    singleStoreDeletionError: 'Нельзя удалить единственный филиал',
    activeUsersPresentInStoreError: 'Пожалуйста, сначала деактивируйте всех пользователей в этом филиале или перенесите их в другой филиал: ',
    name: 'Название',
    address: 'Адрес',
    autoCloseShiftTime: 'Автозакрытие смены',
    autoCloseShiftTimeHint: 'Если вы работаете после 12 ночи, то укажите время при котором заканчивается ваш рабочий день.',
    timezone: 'Часовой пояс филиала',
    showStatsOnTop: 'Показывать статистику на главной',
    show: 'Показывать',
    copySettingsFrom: 'Скопировать настройки с другого филиалы (включенные продукты, цены, методы оплаты, методы покупки)',
    ofd: 'Фискализация ОФД',
    lightKassaInfo: 'Данные Light Kassa',
    cashboxId: 'ID Кассы',
    cashboxPin: 'Pin Кассы',
    login: 'Логин (номер телефона)',
    password: 'Пароль',
    wiponInfo: 'Данные Wipon Kassa',
    profile: 'Профиль',
    cashbox: 'Касса',
    salePoint: 'Тороговая точка',
    saleSection: 'Тороговая секция',
    vatType: 'Учитывать НДС',
    withoutVat: 'Без НДС',
    vat12: 'НДС 12%',
    ofdnone: 'Без фискализации',
    'ofdlight-kassa': 'Light Касса',
    'ofdwipon-kassa': 'Wipon Касса',
    wiponRefreshError: 'Не удалось обновить данные Wipon. Проверьте логин и пароль и попробуйте снова. Текущие настройки кассы не изменены.',
    wiponRefreshUnavailable: 'Wipon не вернул список. Попробуйте через несколько минут. Текущие настройки кассы не изменены.',
    wiponRefreshEmpty: 'Wipon не вернул ни одной позиции для этого профиля. Проверьте профиль в Wipon. Текущие настройки кассы не изменены.',
    wiponRefreshNoProfile: 'Сначала выберите профиль, затем обновите список. Текущие настройки кассы не изменены.',
    missingWalletConfigError: 'Не удалось скопировать настройки. Настройте кошельки для следующих способов оплаты в филиале-источнике: {{methods}}',
    constantsNotLoadedError: 'Настройки ещё загружаются. Подождите немного и попробуйте снова.',
  },
  roles: {
    none: 'Без зарплаты',
    hour: 'Оплата за час',
    day: 'Оплата за день/смену',
    month: 'Оплата за месяц',
    individualSalesPercent: 'Процент от индивидуальных продаж',
    monthlyPlan: 'Ежемесячный план', 
    deleteAdminError: 'Нельзя удалить роль админа. Вы можете ее переименовать.',
    deleteWithActiveUsersError: 'Пожалуйста, сначала деактивируйте всех пользователей c этой ролью или поменяйте им роль: ',
    addingWorkingHoursHint: 'Почасовая и оплата за смену начисляются при добавлении сотрудника в смену в разделе "Смена" и "Зарплата". Оплата за месяц начисляется только в меню "Зарплата".',
    salaryType: 'Тип зарплаты',
    roleBonusType: 'Тип бонусов',
    withoutBonuses: 'Без бонусов',
    individualSalesPercentMinimumSalesHint: 'При выборе этой опции будет рассчитываться бонус сотрудника в зависимости от его индивидуальных продаж. Если вы установите минимальную сумму, то процент от продаж будет начисляться, только если продажи на тот день были выше этой суммы. Накопленные проценты будут видны как зарплата сотрудника в разделе "Зарплата" и в "Отчете по прибыли".',
    individualSalesPercentForBonuses: 'Процент от индивидуальных продаж для расчета бонусов сотрудников',
    minIndividualSalesForDailySales: 'Мимимальная сумма дневных продаж для расчета бонусов сотрудников',
    permissions: 'Доступы',
    chooseAll: 'Выбрать все',
    clear: 'Очистить',
    atLeastOneAdminError: 'В организации должен быть хотя бы один активный {{role}}',
    disableSuccess: 'Пользователь выключен, пожалуйста перезагрузите приложение через минуту',
    enableSuccess: 'Пользователь включен, пожалуйста перезагрузите приложение через минуту',
    newEmployee: 'Новый сотрудник',
    newUserError: 'Ошибка',
    emailInvalidError: 'Некорректный формат email адреса',
    emailAlreadyInUseError: 'Email адрес уже используется другим аккаунтом',
    passwordWeakError: 'Пароль слишком слабый',
    onlyAdminCanChangeAdminError: 'Только администратор может менять email администратора',
    updateUserError: 'Ошибка',
    notAllFieldsFilledOrPasswordShort: 'Не все поля заполнены, либо пароль слишком короткий',
    name: 'Имя',
    email: 'Email',
    password: 'Пароль',
    passwordHint: 'Английскими буквами без пробелов',
    rolesAndPermissions: 'Роли и доступы',
    userLoginHint: 'После сохранения сотрудник может войти в приложение с указанным email и паролем на экране авторизации',
    changePasswordHint: 'Сотрудник может поменять пароль после сохранения - для этого на экране авторизации нужно выбрать Забыл пароль',
    changePassword: 'Сменить пароль',
    newPassword: 'Новый пароль',
  },
  permissions: {
    NewSale: 'Новая продажа', applyDiscount: 'Применять скидки', newSaleWithoutShift: 'Пробивать продажи без открытия смены', sellCustomProducts: 'Продавать кастомные продукты',
    newSaleSettings: 'Менять настройки в Новой продаже', sellOutOfStockProducts: 'Продавать товары, которых нет в наличии',
    SalesHistory: 'История продаж', deleteSale: 'Удаление продажи', // SaleDetail: 'Детали продажи', ReturnSale: 'Возврат продажи', 
    Supplies: 'История приемок', deleteSupply: 'Удаление приемки', // SupplyDetail: 'Детали приемки', addSupply: 'Новая приемка',  markSupplyPaid: 'Оплата приемки',
    WriteOffs: 'История списаний', deleteWriteOff: 'Удаление списания', // WriteOffDetail: 'Детали списания', addWriteOff: 'Новое списание',  WriteOffStats: 'Отчеты по списаниям',
    Spendings: 'Расходы', deleteSpending: 'Удаление расхода', viewAdminSpendingCategories: 'Просмотр категорий расходов для админов', //  SpendingDetail: 'Детали расхода', addSpending: 'Новый расход', deleteSpending: 'Удаление расхода',
    Revisions: 'Ревизии', deleteRevision: 'Удаление ревизии',// RevisionDetail: 'Детали ревизии', RevisionStats: 'Отчеты по ревизиям', addRevision: 'Новая ревизия',
    Manufactures: 'Производство', deleteManufacture: 'Удаление производства',
    Transfers: 'Перемещения товаров', deleteTransfer: 'Удаление перемещения', // TransferDetail: 'Детали перемещения', addTransfer: 'Новое перемещение',
    ComplexSales: 'Комплексные продажи', deleteComplexSale: 'Удаление комплексной продажи', editComplexSaleTemplates: 'Редактирование шаблонов комплексных продаж',
    Payments: 'Платежи',
    Products: 'Товары', deleteProduct: 'Удаление товара', viewInactiveProducts: 'Просмотр неактивных товаров',
    ProductStocks: 'Остатки товаров', 
    Clients: 'Клиенты', ClientDetail: 'Карточка клиента', deleteClient: 'Удаление клиента',
    MarketingLists: 'Рассылки', 
    PrintStickers: 'Печать этикеток',
    Updates: 'Обновления',
    ClientOrders: 'Заказы клиентов',
    Checklist: 'Чек-лист', editChecklistItems: 'Редактирование чек-листа', 
    Shift: 'Смена', changeOthersWorkingHours: 'Редактирование сотрудников в смене / рабочих часов других', editShiftStats: 'Редактирование данных в смене', 
    Salary: 'Зарплата', viewOthersWorkingHours: 'Просмотр зарплат других сотрудников', 
    Stats: 'Отчеты', mainScreenStats: 'Просмотр статистики продаж на главном экране',
    Settings: 'Настройки', editProductCategories: 'Категории товаров', editSuppliers: 'Поставщики', editSettings: 'Редактирование настроек',
    editUsers: 'Редактирование пользователей', 
    viewOtherStores: 'Просмотр других филиалов',
    changeStore: 'Смена филиала',
    billing: 'Тарифы и оплата',
    exportImport: 'Экспорт/Импорт',
  },
  languages: {
    en: 'Английский',
    ru: 'Русский'
  },
  dateService: {
    dayNames: {
      short: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
      long: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
    },
    monthNames: {
      short: ['Янв', 'Фев', 'Март', 'Апр', 'Май', 'Июнь', 'Июль', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
      long: [
        'Январь',
        'Февраль',
        'Март',
        'Апрель',
        'Май',
        'Июнь',
        'Июль',
        'Август',
        'Сентябрь',
        'Октябрь',
        'Ноябрь',
        'Декабрь',
      ],
    },
  },
  currencies: {
    aed: "дирхам ОАЭ",
    afn: "афгани",
    all: "албанский лек",
    amd: "армянский драм",
    ang: "нидерландский антильский гульден",
    aoa: "ангольская кванза",
    ars: "аргентинский песо",
    aud: "австралийский доллар",
    awg: "арубанский флорин",
    azn: "азербайджанский манат",
    bam: "конвертируемая марка Боснии и Герцеговины",
    bbd: "барбадосский доллар",
    bdt: "бангладешская така",
    bgn: "болгарский лев",
    bhd: "бахрейнский динар",
    bif: "бурундийский франк",
    bmd: "бермудский доллар",
    bnd: "брунейский доллар",
    bob: "боливийский боливиано",
    brl: "бразильский реал",
    bsd: "багамский доллар",
    btn: "бутанский нгултрум",
    bwp: "ботсванская пула",
    byn: "белорусский рубль",
    bzd: "белизский доллар",
    cad: "канадский доллар",
    cdf: "конголезский франк",
    chf: "швейцарский франк",
    clp: "чилийский песо",
    cny: "китайский юань",
    cop: "колумбийский песо",
    crc: "костариканский колон",
    cuc: "кубинский конвертируемый песо",
    cup: "кубинский песо",
    cve: "эскудо Кабо-Верде",
    czk: "чешская крона",
    djf: "франк Джибути",
    dkk: "датская крона",
    dop: "доминиканский песо",
    dzd: "алжирский динар",
    egp: "египетский фунт",
    ern: "эритрейская накфа",
    etb: "эфиопский быр",
    eur: "евро",
    fjd: "доллар Фиджи",
    fkp: "фунт Фолклендских островов",
    gbp: "британский фунт стерлингов",
    gel: "грузинский лари",
    ghs: "ганский седи",
    gip: "гибралтарский фунт",
    gmd: "гамбийский даласи",
    gnf: "гвинейский франк",
    gtq: "гватемальский кетсаль",
    gyd: "гайанский доллар",
    hkd: "гонконгский доллар",
    hnl: "гондурасская лемпира",
    hrk: "хорватская куна",
    htg: "гаитянский гурд",
    huf: "венгерский форинт",
    idr: "индонезийская рупия",
    ils: "новый израильский шекель",
    inr: "индийская рупия",
    iqd: "иракский динар",
    irr: "иранский риал",
    isk: "исландская крона",
    jmd: "ямайский доллар",
    jod: "иорданский динар",
    jpy: "японская иена",
    kes: "кенийский шиллинг",
    kgs: "киргизский сом",
    khr: "камбоджийский риель",
    kmf: "коморский франк",
    kpw: "северокорейская вона",
    krw: "южнокорейская вона",
    kwd: "кувейтский динар",
    kyd: "доллар Островов Кайман",
    kzt: "казахский тенге",
    lak: "лаосский кип",
    lbp: "ливанский фунт",
    lkr: "шри-ланкийская рупия",
    lrd: "либерийский доллар",
    lsl: "лоти",
    lyd: "ливийский динар",
    mad: "марокканский дирхам",
    mdl: "молдавский лей",
    mga: "малагасийский ариари",
    mkd: "македонский денар",
    mmk: "мьянманский кьят",
    mnt: "монгольский тугрик",
    mop: "патака Макао",
    mru: "мавританская угия",
    mur: "маврикийская рупия",
    mvr: "мальдивская руфия",
    mwk: "малавийская квача",
    mxn: "мексиканский песо",
    myr: "малайзийский ринггит",
    mzn: "мозамбикский метикал",
    nad: "доллар Намибии",
    ngn: "нигерийская найра",
    nio: "никарагуанская кордоба",
    nok: "норвежская крона",
    npr: "непальская рупия",
    nzd: "новозеландский доллар",
    omr: "оманский риал",
    pab: "панамский бальбоа",
    pen: "перуанский соль",
    pgk: "кина Папуа – Новой Гвинеи",
    rub: "российский рубль",
    try: "турецкая лира",
    uah: "украинская гривна",
    usd: "доллар США",
    uzs: "узбекский сум"
  },
  blockedScreen: {
    title: 'Требуется обновление',
    message: 'Доступна новая версия. Обновите приложение, чтобы продолжить работу.',
    hint: 'Нажмите кнопку ниже, чтобы загрузить и установить обновление.',
    currentVersion: 'Текущая версия',
    requiredVersion: 'Требуемая версия',
    checkForUpdate: 'Обновить сейчас',
    checking: 'Обновляем...',
    noUpdateAvailable: 'Автоматическое обновление недоступно для вашей версии. Установите новую версию из App Store / Play Market — кнопка ниже.',
    updateFailed: 'Не удалось обновить. Попробуйте снова.',
    contactSupport: 'Связаться с поддержкой',
    openAppStore: 'Установить из App Store',
    openPlayStore: 'Установить из Play Market',
    softTitle: 'Доступно обновление',
    softMessage: 'Доступна новая версия. Обновите приложение, чтобы продолжить работу без ограничений.',
    softDismiss: 'Позже',
    softUpdate: 'Обновить',
    bundleIdentity: 'Сборка',
    restartHint: 'Если приложение не перезапустилось, закройте его и откройте снова.',
    bundleTitle: 'Обновляем приложение',
    bundleMessage: 'Загружаем обязательное обновление. Обычно это занимает несколько секунд — приложение перезапустится само.'
  },
  invoice: {
    sale: 'Продажа',
    from: 'от',
    year: 'г.',
    supplier: 'Поставщик',
    buyer: 'Покупатель',
    clientPhone: 'Телефон клиента',
    clientAddress: 'Адрес клиента',
    deliveryAddress: 'Адрес доставки',
    itemNumber: '№',
    itemName: 'Наименование',
    unit: 'Ед.',
    quantity: 'Кол-во',
    price: 'Цена',
    amount: 'Сумма',
    productImage: 'Изображение',
    total: 'Итого',
    vat: 'НДС',
    totalWithVat: 'Итого с НДС',
    withoutTax: 'Без налога (НДС)',
    shippedAmount: 'Отгружено на сумму',
    totalItems: 'Всего наименований',
    onAmount: 'на сумму',
    released: 'Подпись слева',
    received: 'Подпись справа'
  },
  outboxV2: {
    unsynced: 'Не синхронизировано операций: {{count}}. Они сохранены на этом устройстве и будут отправлены автоматически.',
    unsyncedFailing: 'Не синхронизировано операций: {{count}}. Отправить их не удаётся больше часа — обратитесь в поддержку, не удаляйте приложение.',
    unsyncedStopped: 'Не синхронизировано операций: {{count}}. Синхронизация остановлена — обратитесь в поддержку, не удаляйте приложение.',
  },
  whatsapp: {
    noPhone: 'Не указан номер телефона — написать в WhatsApp не на что',
    openFailed: 'Не удалось открыть WhatsApp. Проверьте номер и что WhatsApp установлен.'
  }
}}
